import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  JSONType: { input: any; output: any; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: any; output: any; }
};

export type AccessTokenMutation = {
  __typename?: 'AccessTokenMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<AccessTokenType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type AccessTokenType = {
  __typename?: 'AccessTokenType';
  accessToken: Maybe<Scalars['String']['output']>;
  expiresIn: Maybe<Scalars['Int']['output']>;
  refreshToken: Maybe<Scalars['String']['output']>;
  tokenType: Maybe<Scalars['String']['output']>;
  user: Maybe<UserType>;
};

export type AddPassengerFromWebMutation = {
  __typename?: 'AddPassengerFromWebMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type AdvertisingPaginatedType = {
  __typename?: 'AdvertisingPaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<AdvertisingType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type AdvertisingSingleObjectType = {
  __typename?: 'AdvertisingSingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<AdvertisingType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type AdvertisingType = {
  __typename?: 'AdvertisingType';
  begin: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  end: Maybe<Scalars['DateTime']['output']>;
  facebookLink: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<ImageType>;
  instagramLink: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  showInHome: Scalars['Boolean']['output'];
};

export type AirTraveler = {
  birthCountry: Scalars['String']['input'];
  birthdate: Scalars['Date']['input'];
  countryAccessCode: Scalars['String']['input'];
  documentExpireDate: Scalars['Date']['input'];
  documentIssueCountry: Scalars['String']['input'];
  email: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  idDocumentType: IdDocumentTypeEnum;
  idNumber: Scalars['String']['input'];
  middleName: InputMaybe<Scalars['String']['input']>;
  namePrefix: InputMaybe<NamePrefixEnum>;
  passengerType: PassengerTypesEnum;
  passportCreatedDate: Scalars['Date']['input'];
  phoneAreaCityCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  travelerRefNumber: Scalars['Int']['input'];
};

export type AmadeusAvailabilityInput = {
  departureDate: Scalars['Date']['input'];
  destinationLocationCode: Scalars['String']['input'];
  isRoundTrip: InputMaybe<Scalars['Boolean']['input']>;
  originLocationCode: Scalars['String']['input'];
  passengerQty: Array<InputMaybe<AmadeusPassengerQtyType>>;
  requestId: Scalars['String']['input'];
  returnDate: InputMaybe<Scalars['Date']['input']>;
  returnLocationCode: InputMaybe<Scalars['String']['input']>;
  store: Scalars['Boolean']['input'];
  userId: InputMaybe<Scalars['String']['input']>;
};

export type AmadeusAvailabilityType = {
  __typename?: 'AmadeusAvailabilityType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  requestId: Maybe<Scalars['String']['output']>;
  response: Maybe<AmadeusSearchType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type AmadeusPassengerQtyType = {
  passengerClass: AmadeusPassengerTypesEnum;
  passengerQty: Scalars['Int']['input'];
};

export enum AmadeusPassengerTypesEnum {
  Adult = 'ADULT',
  Child = 'CHILD'
}

export enum AmadeusRouteTypeEnum {
  OneWay = 'ONE_WAY',
  RoundTrip = 'ROUND_TRIP'
}

export type AmadeusSearchType = {
  __typename?: 'AmadeusSearchType';
  adults: Maybe<Scalars['Int']['output']>;
  children: Maybe<Scalars['Int']['output']>;
  departingDate: Scalars['Date']['output'];
  destinationCity: CityType;
  originCity: CityType;
  passengersQty: Scalars['Int']['output'];
  returnCity: Maybe<CityType>;
  returnDate: Maybe<Scalars['Date']['output']>;
  routeType: AmadeusRouteTypeEnum;
};

export type BaggageType = {
  __typename?: 'BaggageType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  qty: Scalars['Int']['output'];
  weightKg: Scalars['Int']['output'];
};

export enum CabinTypesEnum {
  Business = 'BUSINESS',
  Cockpit = 'COCKPIT',
  Economy = 'ECONOMY',
  First = 'FIRST',
  PremiumBusiness = 'PREMIUM_BUSINESS',
  PremiumEconomy = 'PREMIUM_ECONOMY',
  Suite = 'SUITE'
}

export type CarrierType = {
  __typename?: 'CarrierType';
  code: Maybe<Scalars['String']['output']>;
  designation: Maybe<Scalars['String']['output']>;
  footer: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo: Maybe<ImageType>;
  name: Scalars['String']['output'];
};

export type ChangePasswordMutation = {
  __typename?: 'ChangePasswordMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type CityPaginatedType = {
  __typename?: 'CityPaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<CityType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum CitySearchField {
  Code = 'CODE',
  Country = 'COUNTRY',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  IsActive = 'IS_ACTIVE',
  IsDeleted = 'IS_DELETED',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type CitySearchFieldInput = {
  field: InputMaybe<CitySearchField>;
  operation: InputMaybe<Operation>;
  value: Scalars['String']['input'];
};

export type CitySingleObjectType = {
  __typename?: 'CitySingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<CityType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum CitySortField {
  CreatedAt = 'CREATED_AT',
  DeletedAt = 'DELETED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type CitySortFieldInput = {
  desc: InputMaybe<Scalars['Boolean']['input']>;
  selector: InputMaybe<CitySortField>;
};

export type CityType = {
  __typename?: 'CityType';
  code: Scalars['String']['output'];
  country: CountryType;
  id: Scalars['ID']['output'];
  location: Maybe<CoordinatePointType>;
  name: Scalars['String']['output'];
  timezone: Maybe<Scalars['String']['output']>;
};

export type ContactCardUsertype = {
  __typename?: 'ContactCardUsertype';
  agency: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fullName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<ImageType>;
  phoneStaff: Scalars['String']['output'];
};

export type ContactUsMessageInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/** An enumeration. */
export enum ContactUsMessageStatus {
  /** read */
  Read = 'READ',
  /** sent */
  Sent = 'SENT'
}

export type ContactUsMessageType = {
  __typename?: 'ContactUsMessageType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserType>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sent: Scalars['Boolean']['output'];
  status: Maybe<ContactUsMessageStatus>;
  subject: Scalars['String']['output'];
};

export type CoordinatePointType = {
  __typename?: 'CoordinatePointType';
  xCoordinate: Maybe<Scalars['String']['output']>;
  yCoordinate: Maybe<Scalars['String']['output']>;
};

export type CountryPaginatedType = {
  __typename?: 'CountryPaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<CountryType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum CountrySearchField {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  IsActive = 'IS_ACTIVE',
  IsDeleted = 'IS_DELETED',
  Name = 'NAME',
  Nationality = 'NATIONALITY',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type CountrySearchFieldInput = {
  field: InputMaybe<CountrySearchField>;
  operation: InputMaybe<Operation>;
  value: Scalars['String']['input'];
};

export type CountrySingleObjectType = {
  __typename?: 'CountrySingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<CountryType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum CountrySortField {
  CreatedAt = 'CREATED_AT',
  DeletedAt = 'DELETED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type CountrySortFieldInput = {
  desc: InputMaybe<Scalars['Boolean']['input']>;
  selector: InputMaybe<CountrySortField>;
};

export type CountryType = {
  __typename?: 'CountryType';
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nationality: Maybe<Scalars['String']['output']>;
  requirement: Scalars['String']['output'];
};

export type CustomErrorType = {
  __typename?: 'CustomErrorType';
  code: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

export type DestinationCityType = {
  __typename?: 'DestinationCityType';
  country: CountryType;
  id: Scalars['ID']['output'];
  images: Maybe<Array<Maybe<ImageType>>>;
  name: Scalars['String']['output'];
};

export type DestinationListType = {
  __typename?: 'DestinationListType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<DestinationType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type DestinationPaginatedType = {
  __typename?: 'DestinationPaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<DestinationType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type DestinationSingleObjectType = {
  __typename?: 'DestinationSingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<DestinationType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type DestinationType = {
  __typename?: 'DestinationType';
  city: DestinationCityType;
  description: Maybe<Scalars['String']['output']>;
  destination: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Maybe<Array<Maybe<ImageType>>>;
  lodgings: Maybe<Array<Maybe<GenericLodgingType>>>;
  packages: Maybe<Array<Maybe<TouristPackageObjectType>>>;
  slug: Maybe<Scalars['String']['output']>;
  visits: Maybe<Scalars['Int']['output']>;
};

export type EmailVerificationMutation = {
  __typename?: 'EmailVerificationMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<AccessTokenType>;
  status: Maybe<Scalars['Int']['output']>;
  user: Maybe<UserType>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ExperienceRequirementIcon {
  /** accessibility */
  FabFaAccessibleIcon = 'FAB_FA_ACCESSIBLE_ICON',
  /** fort awesome */
  FabFaFortAwesome = 'FAB_FA_FORT_AWESOME',
  /** horse */
  FabFaStickerMule = 'FAB_FA_STICKER_MULE',
  /** air freshener */
  FaFaAirFreshener = 'FA_FA_AIR_FRESHENER',
  /** ambulance */
  FaFaAmbulance = 'FA_FA_AMBULANCE',
  /** anchor */
  FaFaAnchor = 'FA_FA_ANCHOR',
  /** archway */
  FaFaArchway = 'FA_FA_ARCHWAY',
  /** elevator */
  FaFaArrowsAltV = 'FA_FA_ARROWS_ALT_V',
  /** band aid */
  FaFaBandAid = 'FA_FA_BAND_AID',
  /** baseball */
  FaFaBaseballBall = 'FA_FA_BASEBALL_BALL',
  /** basketball */
  FaFaBasketballBall = 'FA_FA_BASKETBALL_BALL',
  /** bath */
  FaFaBath = 'FA_FA_BATH',
  /** bed */
  FaFaBed = 'FA_FA_BED',
  /** beer */
  FaFaBeer = 'FA_FA_BEER',
  /** bell */
  FaFaBell = 'FA_FA_BELL',
  /** bicycle */
  FaFaBicycle = 'FA_FA_BICYCLE',
  /** birthday cake */
  FaFaBirthdayCake = 'FA_FA_BIRTHDAY_CAKE',
  /** blender */
  FaFaBlender = 'FA_FA_BLENDER',
  /** blind */
  FaFaBlind = 'FA_FA_BLIND',
  /** open book */
  FaFaBookOpen = 'FA_FA_BOOK_OPEN',
  /** briefcase medical */
  FaFaBriefcaseMedical = 'FA_FA_BRIEFCASE_MEDICAL',
  /** broom */
  FaFaBroom = 'FA_FA_BROOM',
  /** building */
  FaFaBuilding = 'FA_FA_BUILDING',
  /** bullhorn */
  FaFaBullhorn = 'FA_FA_BULLHORN',
  /** bus */
  FaFaBus = 'FA_FA_BUS',
  /** camera */
  FaFaCamera = 'FA_FA_CAMERA',
  /** capsules */
  FaFaCapsules = 'FA_FA_CAPSULES',
  /** car */
  FaFaCar = 'FA_FA_CAR',
  /** church */
  FaFaChurch = 'FA_FA_CHURCH',
  /** city */
  FaFaCity = 'FA_FA_CITY',
  /** coffee */
  FaFaCoffee = 'FA_FA_COFFEE',
  /** cog */
  FaFaCog = 'FA_FA_COG',
  /** concierge bell */
  FaFaConciergeBell = 'FA_FA_CONCIERGE_BELL',
  /** couch */
  FaFaCouch = 'FA_FA_COUCH',
  /** desktop */
  FaFaDesktop = 'FA_FA_DESKTOP',
  /** dice */
  FaFaDice = 'FA_FA_DICE',
  /** dolly */
  FaFaDolly = 'FA_FA_DOLLY',
  /** dolly flatbed */
  FaFaDollyFlatbed = 'FA_FA_DOLLY_FLATBED',
  /** dumbbell */
  FaFaDumbbell = 'FA_FA_DUMBBELL',
  /** female */
  FaFaFemale = 'FA_FA_FEMALE',
  /** film */
  FaFaFilm = 'FA_FA_FILM',
  /** extinguisher */
  FaFaFireExtinguisher = 'FA_FA_FIRE_EXTINGUISHER',
  /** first aid */
  FaFaFirstAid = 'FA_FA_FIRST_AID',
  /** football ball */
  FaFaFootballBall = 'FA_FA_FOOTBALL_BALL',
  /** football */
  FaFaFutbol = 'FA_FA_FUTBOL',
  /** gamepad */
  FaFaGamepad = 'FA_FA_GAMEPAD',
  /** glass */
  FaFaGlassMartiniAlt = 'FA_FA_GLASS_MARTINI_ALT',
  /** headphones */
  FaFaHeadphones = 'FA_FA_HEADPHONES',
  /** heart */
  FaFaHeart = 'FA_FA_HEART',
  /** heartbeat */
  FaFaHeartbeat = 'FA_FA_HEARTBEAT',
  /** helicopter */
  FaFaHelicopter = 'FA_FA_HELICOPTER',
  /** home */
  FaFaHome = 'FA_FA_HOME',
  /** hospital */
  FaFaHospital = 'FA_FA_HOSPITAL',
  /** hospital */
  FaFaHospitalAlt = 'FA_FA_HOSPITAL_ALT',
  /** hotel */
  FaFaHotel = 'FA_FA_HOTEL',
  /** hot tub */
  FaFaHotTub = 'FA_FA_HOT_TUB',
  /** key */
  FaFaKey = 'FA_FA_KEY',
  /** landmark */
  FaFaLandmark = 'FA_FA_LANDMARK',
  /** laptop */
  FaFaLaptop = 'FA_FA_LAPTOP',
  /** lock */
  FaFaLock = 'FA_FA_LOCK',
  /** lock open */
  FaFaLockOpen = 'FA_FA_LOCK_OPEN',
  /** luggage cart */
  FaFaLuggageCart = 'FA_FA_LUGGAGE_CART',
  /** male */
  FaFaMale = 'FA_FA_MALE',
  /** map marker */
  FaFaMapMarkedAlt = 'FA_FA_MAP_MARKED_ALT',
  /** microphone */
  FaFaMicrophoneAlt = 'FA_FA_MICROPHONE_ALT',
  /** monument */
  FaFaMonument = 'FA_FA_MONUMENT',
  /** mortar pestle */
  FaFaMortarPestle = 'FA_FA_MORTAR_PESTLE',
  /** motorcycle */
  FaFaMotorcycle = 'FA_FA_MOTORCYCLE',
  /** music */
  FaFaMusic = 'FA_FA_MUSIC',
  /** oil can */
  FaFaOilCan = 'FA_FA_OIL_CAN',
  /** parachute box */
  FaFaParachuteBox = 'FA_FA_PARACHUTE_BOX',
  /** parking */
  FaFaParking = 'FA_FA_PARKING',
  /** paw */
  FaFaPaw = 'FA_FA_PAW',
  /** phone */
  FaFaPhone = 'FA_FA_PHONE',
  /** plane */
  FaFaPlane = 'FA_FA_PLANE',
  /** print */
  FaFaPrint = 'FA_FA_PRINT',
  /** school */
  FaFaSchool = 'FA_FA_SCHOOL',
  /** ship */
  FaFaShip = 'FA_FA_SHIP',
  /** show prints */
  FaFaShoePrints = 'FA_FA_SHOE_PRINTS',
  /** shopping carts */
  FaFaShoppingCart = 'FA_FA_SHOPPING_CART',
  /** shower */
  FaFaShower = 'FA_FA_SHOWER',
  /** smoking */
  FaFaSmoking = 'FA_FA_SMOKING',
  /** no smoking */
  FaFaSmokingBan = 'FA_FA_SMOKING_BAN',
  /** snowflake */
  FaFaSnowflake = 'FA_FA_SNOWFLAKE',
  /** store */
  FaFaStore = 'FA_FA_STORE',
  /** subway */
  FaFaSubway = 'FA_FA_SUBWAY',
  /** suitcase */
  FaFaSuitcase = 'FA_FA_SUITCASE',
  /** suitcase rolling */
  FaFaSuitcaseRolling = 'FA_FA_SUITCASE_ROLLING',
  /** swimmer */
  FaFaSwimmer = 'FA_FA_SWIMMER',
  /** pool */
  FaFaSwimmingPool = 'FA_FA_SWIMMING_POOL',
  /** tennis */
  FaFaTableTennis = 'FA_FA_TABLE_TENNIS',
  /** taxi */
  FaFaTaxi = 'FA_FA_TAXI',
  /** train */
  FaFaTrain = 'FA_FA_TRAIN',
  /** transgender */
  FaFaTransgender = 'FA_FA_TRANSGENDER',
  /** tree */
  FaFaTree = 'FA_FA_TREE',
  /** beach */
  FaFaUmbrellaBeach = 'FA_FA_UMBRELLA_BEACH',
  /** utensils */
  FaFaUtensils = 'FA_FA_UTENSILS',
  /** spoon */
  FaFaUtensilSpoon = 'FA_FA_UTENSIL_SPOON',
  /** walking */
  FaFaWalking = 'FA_FA_WALKING',
  /** wheelchair */
  FaFaWheelchair = 'FA_FA_WHEELCHAIR',
  /** wifi */
  FaFaWifi = 'FA_FA_WIFI',
  /** wine */
  FaFaWineGlassAlt = 'FA_FA_WINE_GLASS_ALT',
  /** wrench */
  FaFaWrench = 'FA_FA_WRENCH'
}

export type ExperienceRequirementType = {
  __typename?: 'ExperienceRequirementType';
  icon: ExperienceRequirementIcon;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type FaqPaginatedType = {
  __typename?: 'FAQPaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<FaqType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum FaqSearchField {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  IsActive = 'IS_ACTIVE',
  IsDeleted = 'IS_DELETED',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type FaqSearchFieldInput = {
  field: InputMaybe<FaqSearchField>;
  operation: InputMaybe<Operation>;
  value: Scalars['String']['input'];
};

export type FaqSingleObjectType = {
  __typename?: 'FAQSingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<FaqType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum FaqSortField {
  CreatedAt = 'CREATED_AT',
  DeletedAt = 'DELETED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type FaqSortFieldInput = {
  desc: InputMaybe<Scalars['Boolean']['input']>;
  selector: InputMaybe<FaqSortField>;
};

export type FaqType = {
  __typename?: 'FAQType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserType>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<UserType>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  response: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<UserType>;
};

export type FlightClassType = {
  __typename?: 'FlightClassType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FlightType = {
  __typename?: 'FlightType';
  arrivingCity: CityType;
  arrivingDatetime: Scalars['DateTime']['output'];
  carrier: CarrierType;
  departingCity: CityType;
  departingDatetime: Scalars['DateTime']['output'];
  duration: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
};

export type ForgotPasswordMutation = {
  __typename?: 'ForgotPasswordMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type GenericLodgingType = {
  __typename?: 'GenericLodgingType';
  address: Scalars['String']['output'];
  bathQty: Maybe<Scalars['Int']['output']>;
  category: Maybe<Scalars['Int']['output']>;
  contactName: Scalars['String']['output'];
  coordinates: Maybe<CoordinatePointType>;
  description: Maybe<Scalars['String']['output']>;
  destination: DestinationType;
  email: Scalars['String']['output'];
  enterAfter: Maybe<Scalars['Time']['output']>;
  enterBefore: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  images: Maybe<Array<Maybe<ImageType>>>;
  interests: Maybe<Array<Maybe<InterestType>>>;
  lodgingType: LodgingLodgingType;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  placesInterest: Maybe<Array<Maybe<PlaceInterestType>>>;
  requirements: Maybe<Array<Maybe<ExperienceRequirementType>>>;
  roomQty: Maybe<Scalars['Int']['output']>;
  services: Maybe<Array<Maybe<ServiceType>>>;
};

export enum IdDocumentTypeEnum {
  ConfirmationNumber = 'CONFIRMATION_NUMBER',
  CreditCardNumber = 'CREDIT_CARD_NUMBER',
  Dni = 'DNI',
  DriverLicense = 'DRIVER_LICENSE',
  FrequentFlyerNumber = 'FREQUENT_FLYER_NUMBER',
  LocalIdNumber = 'LOCAL_ID_NUMBER',
  Passport = 'PASSPORT',
  Pp = 'PP',
  TicketNumber = 'TICKET_NUMBER'
}

export type IconVariantType = {
  __typename?: 'IconVariantType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  theme: Maybe<Scalars['String']['output']>;
};

export type ImageType = {
  __typename?: 'ImageType';
  description: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  fullPath: Scalars['String']['output'];
  isMain: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Maybe<Scalars['String']['output']>;
  sizes: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  url: Scalars['String']['output'];
};

export type InterestType = {
  __typename?: 'InterestType';
  address: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  coordinates: Maybe<CoordinatePointType>;
  description: Maybe<Scalars['String']['output']>;
  destination: DestinationType;
  email: Scalars['String']['output'];
  enterAfter: Maybe<Scalars['Time']['output']>;
  enterBefore: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  images: Maybe<Array<Maybe<ImageType>>>;
  interests: Array<InterestType>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  placesInterest: Array<PlaceInterestType>;
  requirements: Array<ExperienceRequirementType>;
  schedule: Maybe<Scalars['JSONString']['output']>;
  services: Array<ServiceType>;
  type: PlaceInterestType;
};

export type ItineraryPassengerType = {
  __typename?: 'ItineraryPassengerType';
  age: Maybe<Scalars['Int']['output']>;
  baggage: Maybe<BaggageType>;
  category: Maybe<Scalars['String']['output']>;
  extraServices: Array<ExtraServiceItemType>;
  id: Scalars['ID']['output'];
  luggage: Array<LuggageItemType>;
  passenger: PassengerObjectType;
};

/** An extra flight service of an itinerary passenger (e.g. assistance). */
export type ExtraServiceItemType = {
  __typename?: 'ExtraServiceItemType';
  leg: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  routeType: Maybe<Scalars['String']['output']>;
};

/** Pets of an itinerary (they belong to it, not to a passenger), per leg. */
export type PetItemType = {
  __typename?: 'PetItemType';
  leg: Maybe<Scalars['String']['output']>;
  qty: Scalars['Int']['output'];
  routeType: Maybe<Scalars['String']['output']>;
  transportType: Maybe<Scalars['String']['output']>;
  transportTypeLabel: Maybe<Scalars['String']['output']>;
};

/** A luggage entry of an itinerary passenger, as the admin shows it. */
export type LuggageItemType = {
  __typename?: 'LuggageItemType';
  asStr: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  leg: Maybe<Scalars['String']['output']>;
  routeType: Maybe<Scalars['String']['output']>;
};

export type ItinerarySingleObjectType = {
  __typename?: 'ItinerarySingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<ItineraryType>;
  status: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum ItineraryStatus {
  /** Not ticket */
  NotTicket = 'NOT_TICKET',
  /** Ticket */
  Ticket = 'TICKET'
}

export type ItineraryType = {
  __typename?: 'ItineraryType';
  approve: Scalars['Boolean']['output'];
  canDownloadPdf: Maybe<Scalars['Boolean']['output']>;
  downloadLink: Maybe<Scalars['String']['output']>;
  draft: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  itineraryCreatedAt: Maybe<Scalars['Date']['output']>;
  itineraryNumber: Maybe<Scalars['Int']['output']>;
  kiuBookingNumber: Maybe<Scalars['String']['output']>;
  outboundFlights: Array<Maybe<RouteType>>;
  passengers: Maybe<Array<Maybe<ItineraryPassengerType>>>;
  pets: Array<PetItemType>;
  qr: Maybe<Scalars['String']['output']>;
  returnFlights: Maybe<Array<Maybe<RouteType>>>;
  status: Maybe<ItineraryStatus>;
  verificationCode: Maybe<Scalars['String']['output']>;
  verifiedPayment: Scalars['Boolean']['output'];
};

export type JobCategoryPaginatedType = {
  __typename?: 'JobCategoryPaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<JobCategoryType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum JobCategorySearchField {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  IsDeleted = 'IS_DELETED',
  Name = 'NAME',
  Slug = 'SLUG',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type JobCategorySearchFieldInput = {
  field: InputMaybe<JobCategorySearchField>;
  operation: InputMaybe<Operation>;
  value: Scalars['String']['input'];
};

export type JobCategorySingleObjectType = {
  __typename?: 'JobCategorySingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<JobCategoryType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum JobCategorySortField {
  CreatedAt = 'CREATED_AT',
  DeletedAt = 'DELETED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type JobCategorySortFieldInput = {
  desc: InputMaybe<Scalars['Boolean']['input']>;
  selector: InputMaybe<JobCategorySortField>;
};

export type JobCategoryType = {
  __typename?: 'JobCategoryType';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<ImageType>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type JobOfferPaginatedType = {
  __typename?: 'JobOfferPaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<JobOfferType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum JobOfferSearchField {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  IsDeleted = 'IS_DELETED',
  Name = 'NAME',
  Slug = 'SLUG',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type JobOfferSearchFieldInput = {
  field: InputMaybe<JobOfferSearchField>;
  operation: InputMaybe<Operation>;
  value: Scalars['String']['input'];
};

export type JobOfferSingleObjectType = {
  __typename?: 'JobOfferSingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<JobOfferType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum JobOfferSortField {
  CreatedAt = 'CREATED_AT',
  DeletedAt = 'DELETED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type JobOfferSortFieldInput = {
  desc: InputMaybe<Scalars['Boolean']['input']>;
  selector: InputMaybe<JobOfferSortField>;
};

export type JobOfferType = {
  __typename?: 'JobOfferType';
  benefits: Maybe<Scalars['String']['output']>;
  category: JobCategoryType;
  description: Maybe<Scalars['String']['output']>;
  functions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  skills: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  workingMode: Maybe<Scalars['String']['output']>;
  workingTime: Maybe<Scalars['String']['output']>;
};

export type JobRequestInput = {
  address: Scalars['String']['input'];
  country: Scalars['ID']['input'];
  curriculum: Scalars['Upload']['input'];
  email: Scalars['String']['input'];
  expectedPayment: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  jobOffer: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  linkedinProfile: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
};

export type JobRequestMutation = {
  __typename?: 'JobRequestMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type KiuAvailabilityInput = {
  airlineCode: InputMaybe<Scalars['String']['input']>;
  cabin: InputMaybe<CabinTypesEnum>;
  combinedItineraries: InputMaybe<Scalars['Boolean']['input']>;
  departureDate: Scalars['Date']['input'];
  destinationLocationCode: Scalars['String']['input'];
  directFlightsOnly: Scalars['Boolean']['input'];
  isFlexibleDates: InputMaybe<Scalars['Boolean']['input']>;
  isRoundTrip: InputMaybe<Scalars['Boolean']['input']>;
  maxResponses: InputMaybe<Scalars['Int']['input']>;
  maxStopsQty: InputMaybe<Scalars['Int']['input']>;
  originLocationCode: Scalars['String']['input'];
  passengersQty: Array<InputMaybe<PassengerQtyType>>;
  returnDate: InputMaybe<Scalars['Date']['input']>;
  returnLocationCode: InputMaybe<Scalars['String']['input']>;
};

export type KiuAvailabilityType = {
  __typename?: 'KIUAvailabilityType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<KiuSearchType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type KiuBookingInformationCustomerType = {
  __typename?: 'KIUBookingInformationCustomerType';
  document: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  givenName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  surname: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type KiuBookingInformationFlightType = {
  __typename?: 'KIUBookingInformationFlightType';
  arrivingCity: Maybe<CityType>;
  arrivingDatetime: Maybe<Scalars['DateTime']['output']>;
  carrier: Maybe<CarrierType>;
  departingCity: Maybe<CityType>;
  departingDatetime: Maybe<Scalars['DateTime']['output']>;
  flightNumber: Maybe<Scalars['String']['output']>;
  rbd: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type KiuBookingInformationInput = {
  bookingReferenceId: Scalars['String']['input'];
};

export type KiuBookingInformationPriceType = {
  __typename?: 'KIUBookingInformationPriceType';
  afterTax: Maybe<KiuPriceType>;
  beforeTax: Maybe<KiuPriceType>;
  fee: Maybe<KiuPriceType>;
  taxes: Maybe<Array<Maybe<KiuTaxType>>>;
  total: Maybe<KiuPriceType>;
};

export type KiuBookingInformationResponseType = {
  __typename?: 'KIUBookingInformationResponseType';
  bookingNumber: Maybe<Scalars['String']['output']>;
  bookingStatus: Maybe<KiuBookingStatusEnum>;
  creationDatetime: Maybe<Scalars['DateTime']['output']>;
  customers: Maybe<Array<Maybe<KiuBookingInformationCustomerType>>>;
  flights: Maybe<Array<Maybe<KiuBookingInformationFlightType>>>;
  lastModificationDatetime: Maybe<Scalars['DateTime']['output']>;
  prices: Maybe<KiuBookingInformationPriceType>;
  ticketTimeLimit: Maybe<Scalars['DateTime']['output']>;
};

export type KiuBookingInformationType = {
  __typename?: 'KIUBookingInformationType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<KiuBookingInformationResponseType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum KiuBookingStatusEnum {
  Cancelled = 'CANCELLED',
  Issued = 'ISSUED',
  Pending = 'PENDING'
}

export type KiuCancelBookingInput = {
  bookingReferenceId: Scalars['String']['input'];
};

export type KiuCancelBookingType = {
  __typename?: 'KIUCancelBookingType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type KiuCreateBookingType = {
  __typename?: 'KIUCreateBookingType';
  bookingNumber: Scalars['String']['output'];
  lastModificationDatetime: Scalars['DateTime']['output'];
  statuses: Array<Maybe<Scalars['String']['output']>>;
  ticketTimeLimit: Scalars['String']['output'];
};

export type KiuCreateReservationMutation = {
  __typename?: 'KIUCreateReservationMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<KiuCreateBookingType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum KiuCurrencyEnum {
  Usd = 'USD'
}

export type KiuDateType = {
  __typename?: 'KIUDateType';
  date: Scalars['Date']['output'];
  isValid: Scalars['Boolean']['output'];
  routes: Maybe<Array<Maybe<KiuRouteType>>>;
};

export type KiuFlightClassType = {
  __typename?: 'KIUFlightClassType';
  code: Scalars['String']['output'];
};

export type KiuFlightType = {
  __typename?: 'KIUFlightType';
  arrivingCity: CityType;
  arrivingDatetime: Scalars['DateTime']['output'];
  carrier: Maybe<CarrierType>;
  departingCity: CityType;
  departingDatetime: Scalars['DateTime']['output'];
  duration: Scalars['String']['output'];
  flightClasses: Maybe<Array<Maybe<KiuFlightClassType>>>;
  flightNumber: Scalars['String']['output'];
  stopQty: Scalars['Int']['output'];
};

export type KiuIssueInput = {
  bookingReferenceId: Scalars['String']['input'];
  flightsRph: Scalars['String']['input'];
  paymentType: PaymentTypeEnum;
};

export type KiuIssueMutation = {
  __typename?: 'KIUIssueMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<Array<Maybe<KiuTicketInfoType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type KiuPassengerFormInput = {
  id: InputMaybe<Scalars['String']['input']>;
  passenger: AirTraveler;
};

export type KiuPriceType = {
  __typename?: 'KIUPriceType';
  amount: Scalars['Float']['output'];
  currency: KiuCurrencyEnum;
};

export type KiuPricesInput = {
  outboundAirlineCodes: Array<InputMaybe<Scalars['String']['input']>>;
  outboundArrivalDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>>;
  outboundDepartureDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>>;
  outboundDestinationLocationCodes: Array<InputMaybe<Scalars['String']['input']>>;
  outboundFlightNumbers: Array<InputMaybe<Scalars['String']['input']>>;
  outboundOriginLocationCodes: Array<InputMaybe<Scalars['String']['input']>>;
  outboundResBookDesigCodes: Array<InputMaybe<Scalars['String']['input']>>;
  passengersQty: Array<InputMaybe<PassengerQtyType>>;
  returnAirlineCodes: Array<InputMaybe<Scalars['String']['input']>>;
  returnArrivalDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>>;
  returnDepartureDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>>;
  returnDestinationLocationCodes: Array<InputMaybe<Scalars['String']['input']>>;
  returnFlightNumbers: Array<InputMaybe<Scalars['String']['input']>>;
  returnOriginLocationCodes: Array<InputMaybe<Scalars['String']['input']>>;
  returnResBookDesigCodes: Array<InputMaybe<Scalars['String']['input']>>;
};

export type KiuPricesResponse = {
  __typename?: 'KIUPricesResponse';
  adultAmount: KiuPriceType;
  baseFare: KiuPriceType;
  childrenAmount: Maybe<KiuPriceType>;
  equivFare: KiuPriceType;
  fee: KiuPriceType;
  oneFee: KiuPriceType;
  taxes: Maybe<Array<Maybe<KiuTaxType>>>;
  total: KiuPriceType;
  totalFare: KiuPriceType;
  totalGds: KiuPriceType;
  totalTaxes: KiuPriceType;
};

export type KiuPricesType = {
  __typename?: 'KIUPricesType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<KiuPricesResponse>;
  status: Maybe<Scalars['Int']['output']>;
};

export type KiuReservationInput = {
  outboundAirlinesCodes: Array<InputMaybe<Scalars['String']['input']>>;
  outboundArrivalCodes: Array<InputMaybe<Scalars['String']['input']>>;
  outboundDepartureCodes: Array<InputMaybe<Scalars['String']['input']>>;
  outboundDepartureDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>>;
  outboundFlightNumbers: Array<InputMaybe<Scalars['String']['input']>>;
  outboundRbds: Array<InputMaybe<Scalars['String']['input']>>;
  returnAirlinesCodes: Array<InputMaybe<Scalars['String']['input']>>;
  returnArrivalCodes: Array<InputMaybe<Scalars['String']['input']>>;
  returnDepartureCodes: Array<InputMaybe<Scalars['String']['input']>>;
  returnDepartureDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>>;
  returnFlightNumbers: Array<InputMaybe<Scalars['String']['input']>>;
  returnRbds: Array<InputMaybe<Scalars['String']['input']>>;
  ticketTimeLimit: Scalars['DateTime']['input'];
  travelers: Array<InputMaybe<AirTraveler>>;
};

export type KiuRouteType = {
  __typename?: 'KIURouteType';
  airlines: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  arrivingDatetime: Scalars['DateTime']['output'];
  categories: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  departingDatetime: Scalars['DateTime']['output'];
  destination: CityType;
  duration: Maybe<Scalars['Time']['output']>;
  errors: Maybe<Scalars['GenericScalar']['output']>;
  flights: Array<Maybe<KiuFlightType>>;
  isValid: Scalars['Boolean']['output'];
  origin: CityType;
  slug: Maybe<Scalars['String']['output']>;
  stopsQty: Scalars['Int']['output'];
};

export enum KiuRouteTypeEnum {
  OneWay = 'ONE_WAY',
  RoundTrip = 'ROUND_TRIP'
}

export type KiuSearchType = {
  __typename?: 'KIUSearchType';
  adults: Maybe<Scalars['Int']['output']>;
  children: Maybe<Scalars['Int']['output']>;
  departingDate: Scalars['Date']['output'];
  destinationCity: CityType;
  invalidCities: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  originCity: CityType;
  outboundRoutes: Maybe<Array<Maybe<KiuDateType>>>;
  passengersQty: Scalars['Int']['output'];
  returnCity: Maybe<CityType>;
  returnDate: Maybe<Scalars['Date']['output']>;
  returnRoutes: Maybe<Array<Maybe<KiuDateType>>>;
  routeType: KiuRouteTypeEnum;
};

export type KiuTaxType = {
  __typename?: 'KIUTaxType';
  code: Scalars['String']['output'];
  price: KiuPriceType;
};

export type KiuTicketInfoType = {
  __typename?: 'KIUTicketInfoType';
  itemNumber: Maybe<Scalars['Int']['output']>;
  ticketNumber: Maybe<Scalars['String']['output']>;
};

export type KiuVoidTicketBookingInput = {
  bookingReferenceId: Scalars['String']['input'];
  eticket: Scalars['String']['input'];
};

export type KiuVoidTicketBookingType = {
  __typename?: 'KIUVoidTicketBookingType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum LodgingLodgingType {
  /** hotel */
  Hotel = 'HOTEL',
  /** house */
  House = 'HOUSE'
}

export type Mutation = {
  __typename?: 'Mutation';
  changePassword: Maybe<ChangePasswordMutation>;
  forgotPassword: Maybe<ForgotPasswordMutation>;
  jobRequest: Maybe<JobRequestMutation>;
  kiuIssue: Maybe<KiuIssueMutation>;
  kiuPassengerForm: Maybe<AddPassengerFromWebMutation>;
  kiuReservation: Maybe<KiuCreateReservationMutation>;
  kiuReserveFlights: Maybe<ReserveKiuFlightsMutation>;
  login: Maybe<AccessTokenMutation>;
  logout: Maybe<RevokeTokenMutation>;
  manageMedia: Maybe<SocialMediaMutation>;
  recoverPassword: Maybe<RecoveryPasswordMutation>;
  review: Maybe<ReviewMutation>;
  sendContactMessage: Maybe<SendContactMessageMutation>;
  signup: Maybe<SignupMutation>;
  subscribe: Maybe<SubscribeNewsletterMutation>;
  unsubscribe: Maybe<UnsubscribeNewsletterMutation>;
  updateProfile: Maybe<UpdateProfileMutation>;
  uploadPcr: Maybe<UploadPcrMutation>;
  verifyAccount: Maybe<VerifyUserAccountMutation>;
  verifyNewEmail: Maybe<EmailVerificationMutation>;
};


export type MutationChangePasswordArgs = {
  confirmPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  callbackUrl: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};


export type MutationJobRequestArgs = {
  input: JobRequestInput;
  recaptchaToken: InputMaybe<Scalars['String']['input']>;
};


export type MutationKiuIssueArgs = {
  input: KiuIssueInput;
};


export type MutationKiuPassengerFormArgs = {
  input: KiuPassengerFormInput;
};


export type MutationKiuReservationArgs = {
  input: KiuReservationInput;
};


export type MutationKiuReserveFlightsArgs = {
  input: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  token: InputMaybe<Scalars['String']['input']>;
};


export type MutationManageMediaArgs = {
  input: SocialMediaInput;
};


export type MutationRecoverPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationReviewArgs = {
  input: ReviewInput;
  recaptchaToken: Scalars['String']['input'];
};


export type MutationSendContactMessageArgs = {
  input: ContactUsMessageInput;
  recaptchaToken: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSubscribeArgs = {
  input: InputMaybe<NewsletterSubscriptionInput>;
  recaptchaToken: Scalars['String']['input'];
};


export type MutationUnsubscribeArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUploadPcrArgs = {
  code: Scalars['String']['input'];
  pcrFile: Scalars['Upload']['input'];
};


export type MutationVerifyAccountArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationVerifyNewEmailArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum NamePrefixEnum {
  Jr = 'JR',
  Mr = 'MR',
  Mrs = 'MRS',
  Mss = 'MSS'
}

export type NewsletterSubscriptionInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};

export type OfficePaginatedType = {
  __typename?: 'OfficePaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<OfficeType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type OfficeType = {
  __typename?: 'OfficeType';
  address: Scalars['String']['output'];
  country: CountryType;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: Maybe<CoordinatePointType>;
  phone: Scalars['String']['output'];
  schedule: Scalars['String']['output'];
};

export enum Operation {
  Contains = 'CONTAINS',
  Equal = 'EQUAL',
  Gt = 'GT',
  Gte = 'GTE',
  Icontains = 'ICONTAINS',
  Lt = 'LT',
  Lte = 'LTE',
  NotEqual = 'NOT_EQUAL',
  NotNull = 'NOT_NULL',
  SelectedDaysAgo = 'SELECTED_DAYS_AGO',
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK',
  ThisYear = 'THIS_YEAR',
  Today = 'TODAY'
}

export type PcrUploadFormType = {
  __typename?: 'PCRUploadFormType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  message: Maybe<Scalars['String']['output']>;
  passenger: Maybe<PassengerType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type PageInfoType = {
  __typename?: 'PageInfoType';
  hasNext: Maybe<Scalars['Boolean']['output']>;
  hasPrev: Maybe<Scalars['Boolean']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  pages: Maybe<Scalars['Int']['output']>;
  total: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum PassengerDocumentType {
  /** Passport */
  Passport = 'PASSPORT',
  /** Passport */
  Pp = 'PP'
}

/** An enumeration. */
export enum PassengerGender {
  /** female */
  Female = 'FEMALE',
  /** male */
  Male = 'MALE'
}

export type PassengerObjectType = {
  __typename?: 'PassengerObjectType';
  birthDate: Maybe<Scalars['Date']['output']>;
  documentType: Maybe<PassengerDocumentType>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender: Maybe<PassengerGender>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  nationality: Maybe<CountryType>;
  passport: Scalars['String']['output'];
  passportCreatedDate: Maybe<Scalars['Date']['output']>;
  passportExpiredDate: Maybe<Scalars['Date']['output']>;
  passportIssueCountry: Maybe<CountryType>;
  phone: Maybe<Scalars['String']['output']>;
  prefix: Maybe<PassengerPrefix>;
};

/** An enumeration. */
export enum PassengerPrefix {
  /** JR */
  Jr = 'JR',
  /** MR */
  Mr = 'MR',
  /** MRS */
  Mrs = 'MRS',
  /** MSS */
  Mss = 'MSS'
}

export type PassengerQtyType = {
  passengerClass: PassengerTypesEnum;
  passengerQty: Scalars['Int']['input'];
};

export type PassengerType = {
  __typename?: 'PassengerType';
  birthDate: Maybe<Scalars['Date']['output']>;
  email: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  passport: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
};

export enum PassengerTypesEnum {
  Adult = 'ADULT',
  Child = 'CHILD',
  Infant = 'INFANT'
}

export enum PaymentMethods {
  Fygaro = 'FYGARO',
  None = 'NONE'
}

export enum PaymentTypeEnum {
  Cash = 'CASH'
}

/** An enumeration. */
export enum PlaceInterestIcon {
  /** accessibility */
  FabFaAccessibleIcon = 'FAB_FA_ACCESSIBLE_ICON',
  /** fort awesome */
  FabFaFortAwesome = 'FAB_FA_FORT_AWESOME',
  /** horse */
  FabFaStickerMule = 'FAB_FA_STICKER_MULE',
  /** air freshener */
  FaFaAirFreshener = 'FA_FA_AIR_FRESHENER',
  /** ambulance */
  FaFaAmbulance = 'FA_FA_AMBULANCE',
  /** anchor */
  FaFaAnchor = 'FA_FA_ANCHOR',
  /** archway */
  FaFaArchway = 'FA_FA_ARCHWAY',
  /** elevator */
  FaFaArrowsAltV = 'FA_FA_ARROWS_ALT_V',
  /** band aid */
  FaFaBandAid = 'FA_FA_BAND_AID',
  /** baseball */
  FaFaBaseballBall = 'FA_FA_BASEBALL_BALL',
  /** basketball */
  FaFaBasketballBall = 'FA_FA_BASKETBALL_BALL',
  /** bath */
  FaFaBath = 'FA_FA_BATH',
  /** bed */
  FaFaBed = 'FA_FA_BED',
  /** beer */
  FaFaBeer = 'FA_FA_BEER',
  /** bell */
  FaFaBell = 'FA_FA_BELL',
  /** bicycle */
  FaFaBicycle = 'FA_FA_BICYCLE',
  /** birthday cake */
  FaFaBirthdayCake = 'FA_FA_BIRTHDAY_CAKE',
  /** blender */
  FaFaBlender = 'FA_FA_BLENDER',
  /** blind */
  FaFaBlind = 'FA_FA_BLIND',
  /** open book */
  FaFaBookOpen = 'FA_FA_BOOK_OPEN',
  /** briefcase medical */
  FaFaBriefcaseMedical = 'FA_FA_BRIEFCASE_MEDICAL',
  /** broom */
  FaFaBroom = 'FA_FA_BROOM',
  /** building */
  FaFaBuilding = 'FA_FA_BUILDING',
  /** bullhorn */
  FaFaBullhorn = 'FA_FA_BULLHORN',
  /** bus */
  FaFaBus = 'FA_FA_BUS',
  /** camera */
  FaFaCamera = 'FA_FA_CAMERA',
  /** capsules */
  FaFaCapsules = 'FA_FA_CAPSULES',
  /** car */
  FaFaCar = 'FA_FA_CAR',
  /** church */
  FaFaChurch = 'FA_FA_CHURCH',
  /** city */
  FaFaCity = 'FA_FA_CITY',
  /** coffee */
  FaFaCoffee = 'FA_FA_COFFEE',
  /** cog */
  FaFaCog = 'FA_FA_COG',
  /** concierge bell */
  FaFaConciergeBell = 'FA_FA_CONCIERGE_BELL',
  /** couch */
  FaFaCouch = 'FA_FA_COUCH',
  /** desktop */
  FaFaDesktop = 'FA_FA_DESKTOP',
  /** dice */
  FaFaDice = 'FA_FA_DICE',
  /** dolly */
  FaFaDolly = 'FA_FA_DOLLY',
  /** dolly flatbed */
  FaFaDollyFlatbed = 'FA_FA_DOLLY_FLATBED',
  /** dumbbell */
  FaFaDumbbell = 'FA_FA_DUMBBELL',
  /** female */
  FaFaFemale = 'FA_FA_FEMALE',
  /** film */
  FaFaFilm = 'FA_FA_FILM',
  /** extinguisher */
  FaFaFireExtinguisher = 'FA_FA_FIRE_EXTINGUISHER',
  /** first aid */
  FaFaFirstAid = 'FA_FA_FIRST_AID',
  /** football ball */
  FaFaFootballBall = 'FA_FA_FOOTBALL_BALL',
  /** football */
  FaFaFutbol = 'FA_FA_FUTBOL',
  /** gamepad */
  FaFaGamepad = 'FA_FA_GAMEPAD',
  /** glass */
  FaFaGlassMartiniAlt = 'FA_FA_GLASS_MARTINI_ALT',
  /** headphones */
  FaFaHeadphones = 'FA_FA_HEADPHONES',
  /** heart */
  FaFaHeart = 'FA_FA_HEART',
  /** heartbeat */
  FaFaHeartbeat = 'FA_FA_HEARTBEAT',
  /** helicopter */
  FaFaHelicopter = 'FA_FA_HELICOPTER',
  /** home */
  FaFaHome = 'FA_FA_HOME',
  /** hospital */
  FaFaHospital = 'FA_FA_HOSPITAL',
  /** hospital */
  FaFaHospitalAlt = 'FA_FA_HOSPITAL_ALT',
  /** hotel */
  FaFaHotel = 'FA_FA_HOTEL',
  /** hot tub */
  FaFaHotTub = 'FA_FA_HOT_TUB',
  /** key */
  FaFaKey = 'FA_FA_KEY',
  /** landmark */
  FaFaLandmark = 'FA_FA_LANDMARK',
  /** laptop */
  FaFaLaptop = 'FA_FA_LAPTOP',
  /** lock */
  FaFaLock = 'FA_FA_LOCK',
  /** lock open */
  FaFaLockOpen = 'FA_FA_LOCK_OPEN',
  /** luggage cart */
  FaFaLuggageCart = 'FA_FA_LUGGAGE_CART',
  /** male */
  FaFaMale = 'FA_FA_MALE',
  /** map marker */
  FaFaMapMarkedAlt = 'FA_FA_MAP_MARKED_ALT',
  /** microphone */
  FaFaMicrophoneAlt = 'FA_FA_MICROPHONE_ALT',
  /** monument */
  FaFaMonument = 'FA_FA_MONUMENT',
  /** mortar pestle */
  FaFaMortarPestle = 'FA_FA_MORTAR_PESTLE',
  /** motorcycle */
  FaFaMotorcycle = 'FA_FA_MOTORCYCLE',
  /** music */
  FaFaMusic = 'FA_FA_MUSIC',
  /** oil can */
  FaFaOilCan = 'FA_FA_OIL_CAN',
  /** parachute box */
  FaFaParachuteBox = 'FA_FA_PARACHUTE_BOX',
  /** parking */
  FaFaParking = 'FA_FA_PARKING',
  /** paw */
  FaFaPaw = 'FA_FA_PAW',
  /** phone */
  FaFaPhone = 'FA_FA_PHONE',
  /** plane */
  FaFaPlane = 'FA_FA_PLANE',
  /** print */
  FaFaPrint = 'FA_FA_PRINT',
  /** school */
  FaFaSchool = 'FA_FA_SCHOOL',
  /** ship */
  FaFaShip = 'FA_FA_SHIP',
  /** show prints */
  FaFaShoePrints = 'FA_FA_SHOE_PRINTS',
  /** shopping carts */
  FaFaShoppingCart = 'FA_FA_SHOPPING_CART',
  /** shower */
  FaFaShower = 'FA_FA_SHOWER',
  /** smoking */
  FaFaSmoking = 'FA_FA_SMOKING',
  /** no smoking */
  FaFaSmokingBan = 'FA_FA_SMOKING_BAN',
  /** snowflake */
  FaFaSnowflake = 'FA_FA_SNOWFLAKE',
  /** store */
  FaFaStore = 'FA_FA_STORE',
  /** subway */
  FaFaSubway = 'FA_FA_SUBWAY',
  /** suitcase */
  FaFaSuitcase = 'FA_FA_SUITCASE',
  /** suitcase rolling */
  FaFaSuitcaseRolling = 'FA_FA_SUITCASE_ROLLING',
  /** swimmer */
  FaFaSwimmer = 'FA_FA_SWIMMER',
  /** pool */
  FaFaSwimmingPool = 'FA_FA_SWIMMING_POOL',
  /** tennis */
  FaFaTableTennis = 'FA_FA_TABLE_TENNIS',
  /** taxi */
  FaFaTaxi = 'FA_FA_TAXI',
  /** train */
  FaFaTrain = 'FA_FA_TRAIN',
  /** transgender */
  FaFaTransgender = 'FA_FA_TRANSGENDER',
  /** tree */
  FaFaTree = 'FA_FA_TREE',
  /** beach */
  FaFaUmbrellaBeach = 'FA_FA_UMBRELLA_BEACH',
  /** utensils */
  FaFaUtensils = 'FA_FA_UTENSILS',
  /** spoon */
  FaFaUtensilSpoon = 'FA_FA_UTENSIL_SPOON',
  /** walking */
  FaFaWalking = 'FA_FA_WALKING',
  /** wheelchair */
  FaFaWheelchair = 'FA_FA_WHEELCHAIR',
  /** wifi */
  FaFaWifi = 'FA_FA_WIFI',
  /** wine */
  FaFaWineGlassAlt = 'FA_FA_WINE_GLASS_ALT',
  /** wrench */
  FaFaWrench = 'FA_FA_WRENCH'
}

export type PlaceInterestType = {
  __typename?: 'PlaceInterestType';
  icon: PlaceInterestIcon;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type PoliciesTypeResponse = {
  __typename?: 'PoliciesTypeResponse';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  policies: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum PolicyTypeEnum {
  CookiesPolicies = 'COOKIES_POLICIES',
  PrivacyPolicies = 'PRIVACY_POLICIES',
  ReturnPolicies = 'RETURN_POLICIES',
  TermsAndConditions = 'TERMS_AND_CONDITIONS'
}

export type Query = {
  __typename?: 'Query';
  advertisingById: Maybe<AdvertisingSingleObjectType>;
  advertisings: Maybe<AdvertisingPaginatedType>;
  amadeusGetAvailability: Maybe<AmadeusAvailabilityType>;
  cities: Maybe<CityPaginatedType>;
  cityById: Maybe<CitySingleObjectType>;
  contactCardInfo: Maybe<SingleContactCardUserType>;
  countries: Maybe<CountryPaginatedType>;
  countryById: Maybe<CountrySingleObjectType>;
  destinationBySlug: Maybe<DestinationSingleObjectType>;
  destinations: Maybe<DestinationPaginatedType>;
  destinationsMostPopulars: Maybe<DestinationListType>;
  destinationsRecently: Maybe<DestinationListType>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  faqById: Maybe<FaqSingleObjectType>;
  faqs: Maybe<FaqPaginatedType>;
  findItinerary: Maybe<ItinerarySingleObjectType>;
  jobCategories: Maybe<JobCategoryPaginatedType>;
  jobCategoryById: Maybe<JobCategorySingleObjectType>;
  jobOfferById: Maybe<JobOfferSingleObjectType>;
  jobOfferBySlug: Maybe<JobOfferSingleObjectType>;
  jobOffers: Maybe<JobOfferPaginatedType>;
  kiuBookingInformation: Maybe<KiuBookingInformationType>;
  kiuCancelBooking: Maybe<KiuCancelBookingType>;
  kiuGetAvailability: Maybe<KiuAvailabilityType>;
  kiuGetPrices: Maybe<KiuPricesType>;
  kiuVoidTicketBooking: Maybe<KiuVoidTicketBookingType>;
  me: Maybe<UserSingleObjectType>;
  momentDestinations: Maybe<DestinationListType>;
  offices: Maybe<OfficePaginatedType>;
  packageById: Maybe<TouristPackageSingleObjectType>;
  packages: Maybe<TouristPackagePaginatedType>;
  payVerification: Maybe<VerifiedPdfType>;
  pcrFileForm: Maybe<PcrUploadFormType>;
  policies: Maybe<PoliciesTypeResponse>;
  slideById: Maybe<SlideSingleObjectType>;
  slides: Maybe<SlidePaginatedType>;
  socialMedia: Maybe<SocialResponseType>;
  status: Scalars['Int']['output'];
  verifiedItineraryPdf: Maybe<VerifiedPdfType>;
  verifyForgotPassword: Maybe<VerifyForgotPasswordType>;
  webMessages: Maybe<WebMessageListType>;
};


export type QueryAdvertisingByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdvertisingsArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAmadeusGetAvailabilityArgs = {
  params: AmadeusAvailabilityInput;
};


export type QueryCitiesArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  searchFields: InputMaybe<Array<InputMaybe<CitySearchFieldInput>>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sortFields: InputMaybe<CitySortFieldInput>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCityByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactCardInfoArgs = {
  token: Scalars['String']['input'];
};


export type QueryCountriesArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  searchFields: InputMaybe<Array<InputMaybe<CountrySearchFieldInput>>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sortFields: InputMaybe<CountrySortFieldInput>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDestinationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryDestinationsArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDestinationsMostPopularsArgs = {
  size: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDestinationsRecentlyArgs = {
  size: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFaqByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFaqsArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  searchFields: InputMaybe<Array<InputMaybe<FaqSearchFieldInput>>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sortFields: InputMaybe<FaqSortFieldInput>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindItineraryArgs = {
  locator: Scalars['String']['input'];
  passport: Scalars['String']['input'];
  recaptchaToken: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobCategoriesArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  searchFields: InputMaybe<Array<InputMaybe<JobCategorySearchFieldInput>>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sortFields: InputMaybe<JobCategorySortFieldInput>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobOfferByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobOfferBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryJobOffersArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  searchFields: InputMaybe<Array<InputMaybe<JobOfferSearchFieldInput>>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sortFields: InputMaybe<JobOfferSortFieldInput>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKiuBookingInformationArgs = {
  params: KiuBookingInformationInput;
};


export type QueryKiuCancelBookingArgs = {
  params: KiuCancelBookingInput;
};


export type QueryKiuGetAvailabilityArgs = {
  params: KiuAvailabilityInput;
};


export type QueryKiuGetPricesArgs = {
  params: KiuPricesInput;
};


export type QueryKiuVoidTicketBookingArgs = {
  params: KiuVoidTicketBookingInput;
};


export type QueryPackageByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPackagesArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPayVerificationArgs = {
  amount: Scalars['Decimal']['input'];
  code: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};


export type QueryPcrFileFormArgs = {
  code: Scalars['String']['input'];
};


export type QueryPoliciesArgs = {
  policyType: PolicyTypeEnum;
};


export type QuerySlideByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySlidesArgs = {
  report: InputMaybe<Scalars['Boolean']['input']>;
  searchFields: InputMaybe<Array<InputMaybe<SlideSearchFieldInput>>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sortFields: InputMaybe<SlideSortFieldInput>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVerifiedItineraryPdfArgs = {
  passport: Scalars['String']['input'];
  recaptchaToken: InputMaybe<Scalars['String']['input']>;
  verificationCode: Scalars['String']['input'];
};


export type QueryVerifyForgotPasswordArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryWebMessagesArgs = {
  place: Scalars['String']['input'];
};

export type RecoveryPasswordMutation = {
  __typename?: 'RecoveryPasswordMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<AccessTokenType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type ReserveKiuFlightsMutation = {
  __typename?: 'ReserveKIUFlightsMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  itinerary: Maybe<ItineraryType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum ReviewEnum {
  TouristPackage = 'TOURIST_PACKAGE'
}

export type ReviewInput = {
  contentType: InputMaybe<ReviewEnum>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  objectId: Scalars['ID']['input'];
  review: Scalars['String']['input'];
  stars: Scalars['Int']['input'];
  stayDate: InputMaybe<Scalars['String']['input']>;
};

export type ReviewMutation = {
  __typename?: 'ReviewMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  review: Maybe<ReviewType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type ReviewType = {
  __typename?: 'ReviewType';
  category: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  review: Scalars['String']['output'];
  stars: Scalars['Int']['output'];
  stayDate: Maybe<Scalars['Date']['output']>;
};

export type RevokeTokenMutation = {
  __typename?: 'RevokeTokenMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum RouteStatus {
  /** cancel confirm hold HX */
  CancelConfirmHoldHx = 'CANCEL_CONFIRM_HOLD_HX',
  /** Confirmed HK */
  ConfirmedHk = 'CONFIRMED_HK',
  /** waiting company confirmation */
  Hm = 'HM',
  /** confirmed without space */
  Mm = 'MM',
  /** reconfirmed */
  Rr = 'RR',
  /** Waiting list HL */
  WaitingListHl = 'WAITING_LIST_HL'
}

export type RouteType = {
  __typename?: 'RouteType';
  flight: FlightType;
  flightClass: FlightClassType;
  id: Scalars['ID']['output'];
  kiuRbd: Maybe<Scalars['String']['output']>;
  meals: Scalars['String']['output'];
  status: Maybe<RouteStatus>;
};

export type SendContactMessageMutation = {
  __typename?: 'SendContactMessageMutation';
  contactMessage: Maybe<ContactUsMessageType>;
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type ServiceType = {
  __typename?: 'ServiceType';
  iconVariants: Maybe<Array<Maybe<IconVariantType>>>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type SignupInput = {
  acceptTerms: Scalars['Boolean']['input'];
  callbackUrl: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
  subscribeNewsletter: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignupMutation = {
  __typename?: 'SignupMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
  user: Maybe<UserType>;
  verificationToken: Maybe<Scalars['String']['output']>;
};

export type SingleContactCardUserType = {
  __typename?: 'SingleContactCardUserType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<ContactCardUsertype>;
  status: Maybe<Scalars['Int']['output']>;
};

export type SlidePaginatedType = {
  __typename?: 'SlidePaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<SlideType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum SlideSearchField {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  IsActive = 'IS_ACTIVE',
  IsDeleted = 'IS_DELETED',
  Section = 'SECTION',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type SlideSearchFieldInput = {
  field: InputMaybe<SlideSearchField>;
  operation: InputMaybe<Operation>;
  value: Scalars['String']['input'];
};

/** An enumeration. */
export enum SlideSection {
  /** experiences */
  Experiences = 'EXPERIENCES',
  /** homepage */
  Homepage = 'HOMEPAGE',
  /** jobs */
  Jobs = 'JOBS'
}

export type SlideSingleObjectType = {
  __typename?: 'SlideSingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<SlideType>;
  status: Maybe<Scalars['Int']['output']>;
};

export enum SlideSortField {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  IsActive = 'IS_ACTIVE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type SlideSortFieldInput = {
  desc: InputMaybe<Scalars['Boolean']['input']>;
  selector: InputMaybe<SlideSortField>;
};

export type SlideType = {
  __typename?: 'SlideType';
  buttonLink: Maybe<Scalars['String']['output']>;
  buttonText: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserType>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<UserType>;
  id: Scalars['ID']['output'];
  image: Maybe<ImageType>;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  section: SlideSection;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<UserType>;
};

export type SocialMediaInput = {
  facebook: InputMaybe<Scalars['String']['input']>;
  instagram: InputMaybe<Scalars['String']['input']>;
  linkedin: InputMaybe<Scalars['String']['input']>;
  pinterest: InputMaybe<Scalars['String']['input']>;
  telegram: InputMaybe<Scalars['String']['input']>;
  youtube: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaMutation = {
  __typename?: 'SocialMediaMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type SocialMediaType = {
  __typename?: 'SocialMediaType';
  facebook: Maybe<Scalars['String']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  linkedin: Maybe<Scalars['String']['output']>;
  pinterest: Maybe<Scalars['String']['output']>;
  telegram: Maybe<Scalars['String']['output']>;
  youtube: Maybe<Scalars['String']['output']>;
};

export type SocialResponseType = {
  __typename?: 'SocialResponseType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  media: Maybe<SocialMediaType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type SubscribeNewsletterMutation = {
  __typename?: 'SubscribeNewsletterMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum TouristPackageBaggageType {
  /** Hand luggage */
  Hand = 'HAND',
  /** Invoiced luggage */
  Invoiced = 'INVOICED'
}

export type TouristPackageLuggageType = {
  __typename?: 'TouristPackageLuggageType';
  baggage: BaggageType;
  id: Scalars['ID']['output'];
  price: Maybe<Scalars['Decimal']['output']>;
  type: TouristPackageBaggageType;
};

export type TouristPackageObjectType = {
  __typename?: 'TouristPackageObjectType';
  baggage: Maybe<Array<Maybe<TouristPackageLuggageType>>>;
  baggageComments: Scalars['String']['output'];
  destination: DestinationType;
  durationNights: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images: Maybe<Array<Maybe<ImageType>>>;
  includeFlights: Scalars['Boolean']['output'];
  lodgings: Maybe<Array<Maybe<GenericLodgingType>>>;
  name: Scalars['String']['output'];
  origins: Maybe<Array<Maybe<TouristPackageOriginType>>>;
  price: Scalars['Decimal']['output'];
  program: Scalars['String']['output'];
  related: Maybe<Array<Maybe<TouristPackageObjectType>>>;
  reviewAverage: Maybe<Scalars['Float']['output']>;
  reviews: Maybe<Array<Maybe<ReviewType>>>;
  services: Array<ServiceType>;
  termsAndConditions: Scalars['String']['output'];
  type: TouristPackageType;
};

export type TouristPackageOriginType = {
  __typename?: 'TouristPackageOriginType';
  availableFrom: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  origin: CountryType;
  price: Scalars['Decimal']['output'];
  visa: Scalars['Boolean']['output'];
  visaPrice: Maybe<Scalars['Decimal']['output']>;
};

export type TouristPackagePaginatedType = {
  __typename?: 'TouristPackagePaginatedType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<TouristPackageObjectType>>>;
  pageInfo: Maybe<PageInfoType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type TouristPackageSingleObjectType = {
  __typename?: 'TouristPackageSingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<TouristPackageObjectType>;
  status: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum TouristPackageType {
  /** Customized */
  Customized = 'CUSTOMIZED',
  /** Static */
  Static = 'STATIC'
}

export type UnsubscribeNewsletterMutation = {
  __typename?: 'UnsubscribeNewsletterMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type UpdateProfileInput = {
  birthday: InputMaybe<Scalars['Date']['input']>;
  callbackUrl: InputMaybe<Scalars['String']['input']>;
  cardExpireAt: InputMaybe<Scalars['Date']['input']>;
  cardNumber: InputMaybe<Scalars['String']['input']>;
  country: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  image: InputMaybe<Scalars['Upload']['input']>;
  lastName: Scalars['String']['input'];
  passport: InputMaybe<Scalars['String']['input']>;
  passportEmissionCountry: InputMaybe<Scalars['ID']['input']>;
  passportEmittedAt: InputMaybe<Scalars['Date']['input']>;
  passportExpireAt: InputMaybe<Scalars['Date']['input']>;
  paymentMethod: InputMaybe<PaymentMethods>;
  phone: InputMaybe<Scalars['String']['input']>;
  removeAvatar: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProfileMutation = {
  __typename?: 'UpdateProfileMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
  user: Maybe<UserType>;
};

export type UploadPcrMutation = {
  __typename?: 'UploadPCRMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  message: Maybe<Scalars['String']['output']>;
  pcrFileUrl: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type UserSingleObjectType = {
  __typename?: 'UserSingleObjectType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  object: Maybe<UserType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type UserType = {
  __typename?: 'UserType';
  birthday: Maybe<Scalars['Date']['output']>;
  cardExpireAt: Maybe<Scalars['Date']['output']>;
  cardNumber: Maybe<Scalars['String']['output']>;
  country: Maybe<CountryType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserType>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<UserType>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<ImageType>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSubscribed: Maybe<Scalars['Boolean']['output']>;
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  passport: Maybe<Scalars['String']['output']>;
  passportEmissionCountry: Maybe<CountryType>;
  passportEmittedAt: Maybe<Scalars['Date']['output']>;
  passportExpireAt: Maybe<Scalars['Date']['output']>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  str_: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<UserType>;
};

export type VerifiedPdfType = {
  __typename?: 'VerifiedPDFType';
  documentUrl: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

export type VerifyForgotPasswordType = {
  __typename?: 'VerifyForgotPasswordType';
  isValid: Scalars['Boolean']['output'];
};

export type VerifyUserAccountMutation = {
  __typename?: 'VerifyUserAccountMutation';
  customErrors: Maybe<Array<Maybe<CustomErrorType>>>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  response: Maybe<AccessTokenType>;
  status: Maybe<Scalars['Int']['output']>;
};

export type WebMessageListType = {
  __typename?: 'WebMessageListType';
  errors: Maybe<Array<Maybe<ErrorType>>>;
  objects: Maybe<Array<Maybe<WebMessageType>>>;
  status: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum WebMessageMessageType {
  /** Error (Red) */
  Error = 'ERROR',
  /** Information (Blue) */
  Info = 'INFO',
  /** Success (Green) */
  Success = 'SUCCESS',
  /** Warning (Yellow) */
  Warning = 'WARNING'
}

/** An enumeration. */
export enum WebMessagePlace {
  /** Flight booking process */
  FlightBookingProcess = 'FLIGHT_BOOKING_PROCESS'
}

export type WebMessageType = {
  __typename?: 'WebMessageType';
  fromDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isActive: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  messageType: WebMessageMessageType;
  place: WebMessagePlace;
  subject: Scalars['String']['output'];
  toDate: Maybe<Scalars['Date']['output']>;
};

export type UserTypeFragment = { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null };

export type AccessTokenTypeFragment = { __typename?: 'AccessTokenType', tokenType: string | null, accessToken: string | null, refreshToken: string | null, expiresIn: number | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null } | null };

export type CityTypeFragment = { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null };

export type CountryTypeFragment = { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string };

export type DestinationCityTypeFragment = { __typename?: 'DestinationCityType', id: string, name: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null };

export type DestinationTypeFragment = { __typename?: 'DestinationType', id: string, destination: string | null, description: string | null, slug: string | null, visits: number | null, city: { __typename?: 'DestinationCityType', id: string, name: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null };

export type TouristPackageObjectTypeFragment = { __typename?: 'TouristPackageObjectType', id: string, name: string };

export type ErrorTypeFragment = { __typename?: 'ErrorType', field: string, messages: Array<string> };

export type ImageTypeFragment = { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null };

export type BaggageTypeFragment = { __typename?: 'BaggageType', id: string, name: string, qty: number, weightKg: number };

export type FlightClassTypeFragment = { __typename?: 'FlightClassType', id: string, name: string };

export type FlightTypeFragment = { __typename?: 'FlightType', id: string, number: string, departingDatetime: any, arrivingDatetime: any, duration: any, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } };

export type RouteTypeFragment = { __typename?: 'RouteType', id: string, status: RouteStatus | null, kiuRbd: string | null, meals: string, flight: { __typename?: 'FlightType', id: string, number: string, departingDatetime: any, arrivingDatetime: any, duration: any, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } }, flightClass: { __typename?: 'FlightClassType', id: string, name: string } };

export type PassengerObjectTypeFragment = { __typename?: 'PassengerObjectType', id: string, firstName: string, lastName: string, email: string | null, birthDate: any | null, gender: PassengerGender | null, passport: string, passportCreatedDate: any | null, passportExpiredDate: any | null, phone: string | null, prefix: PassengerPrefix | null, documentType: PassengerDocumentType | null, nationality: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportIssueCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null };

export type ItineraryPassengerTypeFragment = { __typename?: 'ItineraryPassengerType', id: string, age: number | null, category: string | null, passenger: { __typename?: 'PassengerObjectType', id: string, firstName: string, lastName: string, email: string | null, birthDate: any | null, gender: PassengerGender | null, passport: string, passportCreatedDate: any | null, passportExpiredDate: any | null, phone: string | null, prefix: PassengerPrefix | null, documentType: PassengerDocumentType | null, nationality: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportIssueCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null }, luggage: Array<{ __typename?: 'LuggageItemType', kind: string, label: string, asStr: string, routeType: string | null, leg: string | null }>, extraServices: Array<{ __typename?: 'ExtraServiceItemType', name: string, routeType: string | null, leg: string | null }> };

export type ItineraryTypeFragment = { __typename?: 'ItineraryType', id: string, itineraryNumber: number | null, status: ItineraryStatus | null, draft: boolean, approve: boolean, verifiedPayment: boolean, itineraryCreatedAt: any | null, verificationCode: string | null, downloadLink: string | null, isDeleted: boolean, isActive: boolean, kiuBookingNumber: string | null, canDownloadPdf: boolean | null, qr: string | null, pets: Array<{ __typename?: 'PetItemType', qty: number, transportType: string | null, transportTypeLabel: string | null, routeType: string | null, leg: string | null }>, passengers: Array<{ __typename?: 'ItineraryPassengerType', id: string, age: number | null, category: string | null, passenger: { __typename?: 'PassengerObjectType', id: string, firstName: string, lastName: string, email: string | null, birthDate: any | null, gender: PassengerGender | null, passport: string, passportCreatedDate: any | null, passportExpiredDate: any | null, phone: string | null, prefix: PassengerPrefix | null, documentType: PassengerDocumentType | null, nationality: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportIssueCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null }, luggage: Array<{ __typename?: 'LuggageItemType', kind: string, label: string, asStr: string, routeType: string | null, leg: string | null }>, extraServices: Array<{ __typename?: 'ExtraServiceItemType', name: string, routeType: string | null, leg: string | null }> } | null> | null, outboundFlights: Array<{ __typename?: 'RouteType', id: string, status: RouteStatus | null, kiuRbd: string | null, meals: string, flight: { __typename?: 'FlightType', id: string, number: string, departingDatetime: any, arrivingDatetime: any, duration: any, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } }, flightClass: { __typename?: 'FlightClassType', id: string, name: string } } | null>, returnFlights: Array<{ __typename?: 'RouteType', id: string, status: RouteStatus | null, kiuRbd: string | null, meals: string, flight: { __typename?: 'FlightType', id: string, number: string, departingDatetime: any, arrivingDatetime: any, duration: any, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } }, flightClass: { __typename?: 'FlightClassType', id: string, name: string } } | null> | null };

export type JobCategoryTypeFragment = { __typename?: 'JobCategoryType', id: string, name: string, description: string | null, slug: string, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null };

export type JobOfferTypeFragment = { __typename?: 'JobOfferType', id: string, name: string, description: string | null, workingTime: string | null, workingMode: string | null, location: string | null, benefits: string | null, functions: string | null, skills: string | null, slug: string, category: { __typename?: 'JobCategoryType', id: string, name: string, description: string | null, slug: string, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } };

export type CarrierTypeFragment = { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null };

export type KiuPriceTypeFragment = { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum };

export type KiuTaxTypeFragment = { __typename?: 'KIUTaxType', code: string, price: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum } };

export type KiuDateTypeFragment = { __typename?: 'KIUDateType', date: any, isValid: boolean, routes: Array<{ __typename?: 'KIURouteType', departingDatetime: any, arrivingDatetime: any, stopsQty: number, isValid: boolean, errors: any | null, airlines: Array<string | null> | null, categories: Array<string | null> | null, duration: any | null, origin: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, destination: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, flights: Array<{ __typename?: 'KIUFlightType', departingDatetime: any, arrivingDatetime: any, stopQty: number, flightNumber: string, duration: string, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } | null, flightClasses: Array<{ __typename?: 'KIUFlightClassType', code: string } | null> | null } | null> } | null> | null };

export type CoordinatePointTypeFragment = { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null };

export type OfficeTypeFragment = { __typename?: 'OfficeType', id: string, address: string, phone: string, email: string, schedule: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null };

export type PageInfoTypeFragment = { __typename?: 'PageInfoType', page: number | null, pages: number | null, hasNext: boolean | null, hasPrev: boolean | null, total: number | null };

export type PassengerTypeFragment = { __typename?: 'PassengerType', id: string, email: string | null, birthDate: any | null, passport: string, phone: string | null, fullName: string | null };

export type SocialMediaTypeFragment = { __typename?: 'SocialMediaType', facebook: string | null, instagram: string | null, linkedin: string | null, telegram: string | null, pinterest: string | null, youtube: string | null };

export type WebMessageTypeFragment = { __typename?: 'WebMessageType', id: string, fromDate: any | null, toDate: any | null, subject: string, message: string, isActive: boolean | null, messageType: WebMessageMessageType, place: WebMessagePlace };

export type SignUpMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  subscribeNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  acceptTerms: Scalars['Boolean']['input'];
  recaptchaToken: Scalars['String']['input'];
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signup: { __typename?: 'SignupMutation', status: number | null, verificationToken: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AccessTokenMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, response: { __typename?: 'AccessTokenType', tokenType: string | null, accessToken: string | null, refreshToken: string | null, expiresIn: number | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null } | null } | null } | null };

export type ForgotUserPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForgotUserPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type RecoverPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type RecoverPasswordMutation = { __typename?: 'Mutation', recoverPassword: { __typename?: 'RecoveryPasswordMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, response: { __typename?: 'AccessTokenType', tokenType: string | null, accessToken: string | null, refreshToken: string | null, expiresIn: number | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null } | null } | null } | null };

export type VerifyAccountMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type VerifyAccountMutation = { __typename?: 'Mutation', verifyAccount: { __typename?: 'VerifyUserAccountMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, response: { __typename?: 'AccessTokenType', tokenType: string | null, accessToken: string | null, refreshToken: string | null, expiresIn: number | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null } | null } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  country?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpireAt?: InputMaybe<Scalars['Date']['input']>;
  passportEmittedAt?: InputMaybe<Scalars['Date']['input']>;
  passportEmissionCountry?: InputMaybe<Scalars['ID']['input']>;
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'UpdateProfileMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null } | null } | null };

export type VerifyNewEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type VerifyNewEmailMutation = { __typename?: 'Mutation', verifyNewEmail: { __typename?: 'EmailVerificationMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, response: { __typename?: 'AccessTokenType', tokenType: string | null, accessToken: string | null, refreshToken: string | null, expiresIn: number | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null } | null } | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null } | null } | null };

export type SendContactUsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  message: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type SendContactUsMutation = { __typename?: 'Mutation', sendContactMessage: { __typename?: 'SendContactMessageMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, contactMessage: { __typename?: 'ContactUsMessageType', name: string, email: string, subject: string, message: string, sent: boolean, createdAt: any } | null } | null };

export type KiuReserveFlightsMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type KiuReserveFlightsMutation = { __typename?: 'Mutation', kiuReserveFlights: { __typename?: 'ReserveKIUFlightsMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, customErrors: Array<{ __typename?: 'CustomErrorType', field: string, messages: Array<string>, code: string | null } | null> | null, itinerary: { __typename?: 'ItineraryType', id: string, itineraryNumber: number | null, status: ItineraryStatus | null, draft: boolean, approve: boolean, verifiedPayment: boolean, itineraryCreatedAt: any | null, verificationCode: string | null, downloadLink: string | null, isDeleted: boolean, isActive: boolean, kiuBookingNumber: string | null, canDownloadPdf: boolean | null, qr: string | null, pets: Array<{ __typename?: 'PetItemType', qty: number, transportType: string | null, transportTypeLabel: string | null, routeType: string | null, leg: string | null }>, passengers: Array<{ __typename?: 'ItineraryPassengerType', id: string, age: number | null, category: string | null, passenger: { __typename?: 'PassengerObjectType', id: string, firstName: string, lastName: string, email: string | null, birthDate: any | null, gender: PassengerGender | null, passport: string, passportCreatedDate: any | null, passportExpiredDate: any | null, phone: string | null, prefix: PassengerPrefix | null, documentType: PassengerDocumentType | null, nationality: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportIssueCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null }, luggage: Array<{ __typename?: 'LuggageItemType', kind: string, label: string, asStr: string, routeType: string | null, leg: string | null }>, extraServices: Array<{ __typename?: 'ExtraServiceItemType', name: string, routeType: string | null, leg: string | null }> } | null> | null, outboundFlights: Array<{ __typename?: 'RouteType', id: string, status: RouteStatus | null, kiuRbd: string | null, meals: string, flight: { __typename?: 'FlightType', id: string, number: string, departingDatetime: any, arrivingDatetime: any, duration: any, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } }, flightClass: { __typename?: 'FlightClassType', id: string, name: string } } | null>, returnFlights: Array<{ __typename?: 'RouteType', id: string, status: RouteStatus | null, kiuRbd: string | null, meals: string, flight: { __typename?: 'FlightType', id: string, number: string, departingDatetime: any, arrivingDatetime: any, duration: any, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } }, flightClass: { __typename?: 'FlightClassType', id: string, name: string } } | null> | null } | null } | null };

export type KiuPassengerFormMutationVariables = Exact<{
  input: KiuPassengerFormInput;
}>;


export type KiuPassengerFormMutation = { __typename?: 'Mutation', kiuPassengerForm: { __typename?: 'AddPassengerFromWebMutation', status: number | null, response: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type JobOfferApplyMutationVariables = Exact<{
  jobOffer: Scalars['ID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  address: Scalars['String']['input'];
  country: Scalars['ID']['input'];
  linkedinProfile?: InputMaybe<Scalars['String']['input']>;
  curriculum: Scalars['Upload']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  expectedPayment?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobOfferApplyMutation = { __typename?: 'Mutation', jobRequest: { __typename?: 'JobRequestMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SubscribeMutationVariables = Exact<{
  fullName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type SubscribeMutation = { __typename?: 'Mutation', subscribe: { __typename?: 'SubscribeNewsletterMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UnsubscribeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UnsubscribeMutation = { __typename?: 'Mutation', unsubscribe: { __typename?: 'UnsubscribeNewsletterMutation', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AdvertisingQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdvertisingQuery = { __typename?: 'Query', advertisings: { __typename?: 'AdvertisingPaginatedType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, pageInfo: { __typename?: 'PageInfoType', page: number | null, pages: number | null, hasNext: boolean | null, hasPrev: boolean | null, total: number | null } | null, objects: Array<{ __typename?: 'AdvertisingType', id: string, name: string | null, description: string | null, begin: any | null, end: any | null, facebookLink: string | null, instagramLink: string | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } | null> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'UserSingleObjectType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, object: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string, emailVerified: boolean, isSuperuser: boolean, isActive: boolean, isStaff: boolean, phone: string | null, birthday: any | null, passport: string | null, passportExpireAt: any | null, cardNumber: string | null, cardExpireAt: any | null, paymentMethod: string | null, passportEmittedAt: any | null, isSubscribed: boolean | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportEmissionCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null } | null } | null };

export type VerifyForgotPasswordQueryVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type VerifyForgotPasswordQuery = { __typename?: 'Query', verifyForgotPassword: { __typename?: 'VerifyForgotPasswordType', isValid: boolean } | null };

export type CharterReconfirmationInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CharterReconfirmationInfoQuery = { __typename?: 'Query', charterReconfirmationInfo: { __typename?: 'CharterReconfirmationInfoType', token: string | null, itineraryNumber: number | null, canReconfirm: boolean | null, reconfirmationStatus: string | null, reconfirmationStatusDisplay: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, status: number | null, flight: { __typename?: 'FlightType', number: string, departingDatetime: any, arrivingDatetime: any, departingCity: { __typename?: 'CityType', name: string, code: string }, arrivingCity: { __typename?: 'CityType', name: string, code: string }, carrier: { __typename?: 'CarrierType', name: string } } | null, passengers: Array<{ __typename?: 'CharterPassengerInfoType', id: number | null, fullName: string | null, passport: string | null, status: string | null, statusDisplay: string | null } | null> | null } | null };

export type PassengerDecisionInput = {
  decision: Scalars['String']['input'];
  passport: Scalars['String']['input'];
};

export type SendCharterReconfirmationCodeMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type SendCharterReconfirmationCodeMutation = { __typename?: 'Mutation', sendCharterReconfirmationCode: { __typename?: 'SendCharterReconfirmationCodeMutation', status: number | null, message: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type ConfirmCharterReturnDecisionMutationVariables = Exact<{
  token: Scalars['String']['input'];
  code: Scalars['String']['input'];
  passengers: Array<InputMaybe<PassengerDecisionInput>> | InputMaybe<PassengerDecisionInput>;
  remarks?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmCharterReturnDecisionMutation = { __typename?: 'Mutation', confirmCharterReturn: { __typename?: 'ConfirmCharterReturnMutation', status: number | null, message: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type ContactCardInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ContactCardInfoQuery = { __typename?: 'Query', contactCardInfo: { __typename?: 'SingleContactCardUserType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, object: { __typename?: 'ContactCardUsertype', id: string, fullName: string | null, email: string, phoneStaff: string, agency: string | null, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } | null } | null };

export type CitiesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CitiesQuery = { __typename?: 'Query', cities: { __typename?: 'CityPaginatedType', status: number | null, pageInfo: { __typename?: 'PageInfoType', page: number | null, pages: number | null, hasNext: boolean | null, hasPrev: boolean | null, total: number | null } | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null } | null> | null } | null };

export type CountriesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CountriesQuery = { __typename?: 'Query', countries: { __typename?: 'CountryPaginatedType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null> | null } | null };

export type DestinationsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DestinationsQuery = { __typename?: 'Query', destinations: { __typename?: 'DestinationPaginatedType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'DestinationType', id: string, destination: string | null, description: string | null, slug: string | null, visits: number | null, city: { __typename?: 'DestinationCityType', id: string, name: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null } | null> | null } | null };

export type DestinationBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type DestinationBySlugQuery = { __typename?: 'Query', destinationBySlug: { __typename?: 'DestinationSingleObjectType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, object: { __typename?: 'DestinationType', id: string, destination: string | null, description: string | null, slug: string | null, visits: number | null, city: { __typename?: 'DestinationCityType', id: string, name: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null } | null } | null };

export type DestinationsMostPopularsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DestinationsMostPopularsQuery = { __typename?: 'Query', destinationsMostPopulars: { __typename?: 'DestinationListType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'DestinationType', id: string, destination: string | null, description: string | null, slug: string | null, visits: number | null, city: { __typename?: 'DestinationCityType', id: string, name: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null } | null> | null } | null };

export type MomentDestinationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MomentDestinationsQuery = { __typename?: 'Query', momentDestinations: { __typename?: 'DestinationListType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'DestinationType', id: string, destination: string | null, description: string | null, slug: string | null, visits: number | null, city: { __typename?: 'DestinationCityType', id: string, name: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null } | null> | null } | null };

export type DestinationsRecentlyQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DestinationsRecentlyQuery = { __typename?: 'Query', destinationsRecently: { __typename?: 'DestinationListType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'DestinationType', id: string, destination: string | null, description: string | null, slug: string | null, visits: number | null, city: { __typename?: 'DestinationCityType', id: string, name: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null }, images: Array<{ __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null> | null } | null> | null } | null };

export type FaqsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
  searchFields?: InputMaybe<Array<InputMaybe<FaqSearchFieldInput>> | InputMaybe<FaqSearchFieldInput>>;
  sortFields?: InputMaybe<FaqSortFieldInput>;
}>;


export type FaqsQuery = { __typename?: 'Query', faqs: { __typename?: 'FAQPaginatedType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, pageInfo: { __typename?: 'PageInfoType', page: number | null, pages: number | null, hasNext: boolean | null, hasPrev: boolean | null, total: number | null } | null, objects: Array<{ __typename?: 'FAQType', id: string, question: string, response: string } | null> | null } | null };

export type FindItineraryQueryVariables = Exact<{
  locator: Scalars['String']['input'];
  passport: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindItineraryQuery = { __typename?: 'Query', findItinerary: { __typename?: 'ItinerarySingleObjectType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, object: { __typename?: 'ItineraryType', id: string, itineraryNumber: number | null, status: ItineraryStatus | null, draft: boolean, approve: boolean, verifiedPayment: boolean, itineraryCreatedAt: any | null, verificationCode: string | null, downloadLink: string | null, isDeleted: boolean, isActive: boolean, kiuBookingNumber: string | null, canDownloadPdf: boolean | null, qr: string | null, pets: Array<{ __typename?: 'PetItemType', qty: number, transportType: string | null, transportTypeLabel: string | null, routeType: string | null, leg: string | null }>, passengers: Array<{ __typename?: 'ItineraryPassengerType', id: string, age: number | null, category: string | null, passenger: { __typename?: 'PassengerObjectType', id: string, firstName: string, lastName: string, email: string | null, birthDate: any | null, gender: PassengerGender | null, passport: string, passportCreatedDate: any | null, passportExpiredDate: any | null, phone: string | null, prefix: PassengerPrefix | null, documentType: PassengerDocumentType | null, nationality: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null, passportIssueCountry: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string } | null }, luggage: Array<{ __typename?: 'LuggageItemType', kind: string, label: string, asStr: string, routeType: string | null, leg: string | null }>, extraServices: Array<{ __typename?: 'ExtraServiceItemType', name: string, routeType: string | null, leg: string | null }> } | null> | null, outboundFlights: Array<{ __typename?: 'RouteType', id: string, status: RouteStatus | null, kiuRbd: string | null, meals: string, flight: { __typename?: 'FlightType', id: string, number: string, departingDatetime: any, arrivingDatetime: any, duration: any, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } }, flightClass: { __typename?: 'FlightClassType', id: string, name: string } } | null>, returnFlights: Array<{ __typename?: 'RouteType', id: string, status: RouteStatus | null, kiuRbd: string | null, meals: string, flight: { __typename?: 'FlightType', id: string, number: string, departingDatetime: any, arrivingDatetime: any, duration: any, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } }, flightClass: { __typename?: 'FlightClassType', id: string, name: string } } | null> | null } | null } | null };

export type JobOffersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type JobOffersQuery = { __typename?: 'Query', jobOffers: { __typename?: 'JobOfferPaginatedType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'JobOfferType', id: string, name: string, description: string | null, workingTime: string | null, workingMode: string | null, location: string | null, benefits: string | null, functions: string | null, skills: string | null, slug: string, category: { __typename?: 'JobCategoryType', id: string, name: string, description: string | null, slug: string, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } } | null> | null, pageInfo: { __typename?: 'PageInfoType', page: number | null, pages: number | null, hasNext: boolean | null, hasPrev: boolean | null, total: number | null } | null } | null };

export type JobOfferBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type JobOfferBySlugQuery = { __typename?: 'Query', jobOfferBySlug: { __typename?: 'JobOfferSingleObjectType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, object: { __typename?: 'JobOfferType', id: string, name: string, description: string | null, workingTime: string | null, workingMode: string | null, location: string | null, benefits: string | null, functions: string | null, skills: string | null, slug: string, category: { __typename?: 'JobCategoryType', id: string, name: string, description: string | null, slug: string, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } } | null } | null };

export type KiuGetAvailabilityQueryVariables = Exact<{
  originLocationCode: Scalars['String']['input'];
  destinationLocationCode: Scalars['String']['input'];
  cabin?: InputMaybe<CabinTypesEnum>;
  maxStopsQty?: InputMaybe<Scalars['Int']['input']>;
  airlineCode?: InputMaybe<Scalars['String']['input']>;
  departureDate: Scalars['Date']['input'];
  returnDate?: InputMaybe<Scalars['Date']['input']>;
  directFlightsOnly: Scalars['Boolean']['input'];
  maxResponses?: InputMaybe<Scalars['Int']['input']>;
  combinedItineraries?: InputMaybe<Scalars['Boolean']['input']>;
  isRoundTrip?: InputMaybe<Scalars['Boolean']['input']>;
  isFlexibleDates?: InputMaybe<Scalars['Boolean']['input']>;
  passengersQty: Array<InputMaybe<PassengerQtyType>> | InputMaybe<PassengerQtyType>;
  returnLocationCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type KiuGetAvailabilityQuery = { __typename?: 'Query', kiuGetAvailability: { __typename?: 'KIUAvailabilityType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, response: { __typename?: 'KIUSearchType', routeType: KiuRouteTypeEnum, departingDate: any, returnDate: any | null, adults: number | null, children: number | null, passengersQty: number, invalidCities: Array<string | null> | null, originCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, destinationCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, returnCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null } | null, outboundRoutes: Array<{ __typename?: 'KIUDateType', date: any, isValid: boolean, routes: Array<{ __typename?: 'KIURouteType', departingDatetime: any, arrivingDatetime: any, stopsQty: number, isValid: boolean, errors: any | null, airlines: Array<string | null> | null, categories: Array<string | null> | null, duration: any | null, origin: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, destination: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, flights: Array<{ __typename?: 'KIUFlightType', departingDatetime: any, arrivingDatetime: any, stopQty: number, flightNumber: string, duration: string, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } | null, flightClasses: Array<{ __typename?: 'KIUFlightClassType', code: string } | null> | null } | null> } | null> | null } | null> | null, returnRoutes: Array<{ __typename?: 'KIUDateType', date: any, isValid: boolean, routes: Array<{ __typename?: 'KIURouteType', departingDatetime: any, arrivingDatetime: any, stopsQty: number, isValid: boolean, errors: any | null, airlines: Array<string | null> | null, categories: Array<string | null> | null, duration: any | null, origin: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, destination: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, flights: Array<{ __typename?: 'KIUFlightType', departingDatetime: any, arrivingDatetime: any, stopQty: number, flightNumber: string, duration: string, departingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, arrivingCity: { __typename?: 'CityType', id: string, name: string, code: string, timezone: string | null, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null }, carrier: { __typename?: 'CarrierType', id: string, name: string, code: string | null, designation: string | null, footer: string | null, logo: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } | null, flightClasses: Array<{ __typename?: 'KIUFlightClassType', code: string } | null> | null } | null> } | null> | null } | null> | null } | null } | null };

export type KiuGetPricesQueryVariables = Exact<{
  outboundDepartureDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>> | InputMaybe<Scalars['DateTime']['input']>;
  outboundArrivalDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>> | InputMaybe<Scalars['DateTime']['input']>;
  outboundFlightNumbers: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  outboundResBookDesigCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  outboundAirlineCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  outboundOriginLocationCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  outboundDestinationLocationCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  returnDepartureDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>> | InputMaybe<Scalars['DateTime']['input']>;
  returnArrivalDatetimes: Array<InputMaybe<Scalars['DateTime']['input']>> | InputMaybe<Scalars['DateTime']['input']>;
  returnFlightNumbers: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  returnResBookDesigCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  returnAirlineCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  returnOriginLocationCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  returnDestinationLocationCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  passengersQty: Array<InputMaybe<PassengerQtyType>> | InputMaybe<PassengerQtyType>;
}>;


export type KiuGetPricesQuery = { __typename?: 'Query', kiuGetPrices: { __typename?: 'KIUPricesType', status: number | null, errors: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null, response: { __typename?: 'KIUPricesResponse', baseFare: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum }, equivFare: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum }, taxes: Array<{ __typename?: 'KIUTaxType', code: string, price: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum } } | null> | null, totalFare: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum }, totalTaxes: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum }, fee: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum }, totalGds: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum }, total: { __typename?: 'KIUPriceType', amount: number, currency: KiuCurrencyEnum } } | null } | null };

export type OfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficesQuery = { __typename?: 'Query', offices: { __typename?: 'OfficePaginatedType', status: number | null, pageInfo: { __typename?: 'PageInfoType', page: number | null, pages: number | null, hasNext: boolean | null, hasPrev: boolean | null, total: number | null } | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'OfficeType', id: string, address: string, phone: string, email: string, schedule: string, country: { __typename?: 'CountryType', id: string, code: string | null, name: string, nationality: string | null, requirement: string }, location: { __typename?: 'CoordinatePointType', xCoordinate: string | null, yCoordinate: string | null } | null } | null> | null } | null };

export type PackagesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PackagesQuery = { __typename?: 'Query', packages: { __typename?: 'TouristPackagePaginatedType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, pageInfo: { __typename?: 'PageInfoType', page: number | null, pages: number | null, hasNext: boolean | null, hasPrev: boolean | null, total: number | null } | null, objects: Array<{ __typename?: 'TouristPackageObjectType', id: string, name: string } | null> | null } | null };

export type PackageByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PackageByIdQuery = { __typename?: 'Query', packageById: { __typename?: 'TouristPackageSingleObjectType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, object: { __typename?: 'TouristPackageObjectType', id: string, name: string } | null } | null };

export type PayVerificationQueryVariables = Exact<{
  code: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type PayVerificationQuery = { __typename?: 'Query', payVerification: { __typename?: 'VerifiedPDFType', status: number | null, documentUrl: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type PoliciesQueryVariables = Exact<{
  policyType: PolicyTypeEnum;
}>;


export type PoliciesQuery = { __typename?: 'Query', policies: { __typename?: 'PoliciesTypeResponse', status: number | null, policies: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SlidesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
  searchFields?: InputMaybe<Array<InputMaybe<SlideSearchFieldInput>> | InputMaybe<SlideSearchFieldInput>>;
  sortFields?: InputMaybe<SlideSortFieldInput>;
}>;


export type SlidesQuery = { __typename?: 'Query', slides: { __typename?: 'SlidePaginatedType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, pageInfo: { __typename?: 'PageInfoType', page: number | null, pages: number | null, hasNext: boolean | null, hasPrev: boolean | null, total: number | null } | null, objects: Array<{ __typename?: 'SlideType', title: string | null, subtitle: string | null, buttonText: string | null, buttonLink: string | null, section: SlideSection, image: { __typename?: 'ImageType', name: string, path: string, extension: string, size: string | null, fullPath: string, sizes: Array<number | null> | null, url: string, description: string | null, isMain: boolean | null } | null } | null> | null } | null };

export type SocialMediaQueryVariables = Exact<{ [key: string]: never; }>;


export type SocialMediaQuery = { __typename?: 'Query', socialMedia: { __typename?: 'SocialResponseType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, media: { __typename?: 'SocialMediaType', facebook: string | null, instagram: string | null, linkedin: string | null, telegram: string | null, pinterest: string | null, youtube: string | null } | null } | null };

export type VerifiedItineraryPdfQueryVariables = Exact<{
  verificationCode: Scalars['String']['input'];
  passport: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type VerifiedItineraryPdfQuery = { __typename?: 'Query', verifiedItineraryPdf: { __typename?: 'VerifiedPDFType', status: number | null, itineraryNumber: number | null, passport: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type WebMessagesQueryVariables = Exact<{
  place: Scalars['String']['input'];
}>;


export type WebMessagesQuery = { __typename?: 'Query', webMessages: { __typename?: 'WebMessageListType', status: number | null, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, objects: Array<{ __typename?: 'WebMessageType', id: string, fromDate: any | null, toDate: any | null, subject: string, message: string, isActive: boolean | null, messageType: WebMessageMessageType, place: WebMessagePlace } | null> | null } | null };

export const ImageTypeFragmentDoc = gql`
    fragment ImageType on ImageType {
  name
  path
  extension
  size
  fullPath
  sizes
  url
  description
  isMain
}
    `;
export const CountryTypeFragmentDoc = gql`
    fragment CountryType on CountryType {
  id
  code
  name
  nationality
  requirement
}
    `;
export const UserTypeFragmentDoc = gql`
    fragment UserType on UserType {
  id
  firstName
  lastName
  email
  emailVerified
  isSuperuser
  isActive
  isStaff
  image {
    ...ImageType
  }
  phone
  birthday
  country {
    ...CountryType
  }
  passport
  passportExpireAt
  cardNumber
  cardExpireAt
  paymentMethod
  passportEmittedAt
  isSubscribed
  passportEmissionCountry {
    ...CountryType
  }
}
    ${ImageTypeFragmentDoc}
${CountryTypeFragmentDoc}`;
export const AccessTokenTypeFragmentDoc = gql`
    fragment AccessTokenType on AccessTokenType {
  tokenType
  accessToken
  refreshToken
  expiresIn
  user {
    ...UserType
  }
}
    ${UserTypeFragmentDoc}`;
export const DestinationCityTypeFragmentDoc = gql`
    fragment DestinationCityType on DestinationCityType {
  id
  name
  country {
    ...CountryType
  }
  images {
    ...ImageType
  }
}
    ${CountryTypeFragmentDoc}
${ImageTypeFragmentDoc}`;
export const DestinationTypeFragmentDoc = gql`
    fragment DestinationType on DestinationType {
  id
  destination
  city {
    ...DestinationCityType
  }
  description
  slug
  visits
  images {
    ...ImageType
  }
}
    ${DestinationCityTypeFragmentDoc}
${ImageTypeFragmentDoc}`;
export const TouristPackageObjectTypeFragmentDoc = gql`
    fragment TouristPackageObjectType on TouristPackageObjectType {
  id
  name
}
    `;
export const ErrorTypeFragmentDoc = gql`
    fragment ErrorType on ErrorType {
  field
  messages
}
    `;
export const PassengerObjectTypeFragmentDoc = gql`
    fragment PassengerObjectType on PassengerObjectType {
  id
  firstName
  lastName
  email
  birthDate
  nationality {
    ...CountryType
  }
  gender
  passport
  passportCreatedDate
  passportExpiredDate
  passportIssueCountry {
    ...CountryType
  }
  phone
  prefix
  documentType
}
    ${CountryTypeFragmentDoc}`;
export const BaggageTypeFragmentDoc = gql`
    fragment BaggageType on BaggageType {
  id
  name
  qty
  weightKg
}
    `;
export const ItineraryPassengerTypeFragmentDoc = gql`
    fragment ItineraryPassengerType on ItineraryPassengerType {
  id
  passenger {
    ...PassengerObjectType
  }
  luggage {
    kind
    label
    asStr
    routeType
    leg
  }
  extraServices {
    name
    routeType
    leg
  }
  age
  category
}
    ${PassengerObjectTypeFragmentDoc}`;
export const CoordinatePointTypeFragmentDoc = gql`
    fragment CoordinatePointType on CoordinatePointType {
  xCoordinate
  yCoordinate
}
    `;
export const CityTypeFragmentDoc = gql`
    fragment CityType on CityType {
  id
  name
  code
  country {
    ...CountryType
  }
  timezone
  location {
    ...CoordinatePointType
  }
}
    ${CountryTypeFragmentDoc}
${CoordinatePointTypeFragmentDoc}`;
export const CarrierTypeFragmentDoc = gql`
    fragment CarrierType on CarrierType {
  id
  name
  code
  designation
  logo {
    ...ImageType
  }
  footer
}
    ${ImageTypeFragmentDoc}`;
export const FlightTypeFragmentDoc = gql`
    fragment FlightType on FlightType {
  id
  number
  departingCity {
    ...CityType
  }
  arrivingCity {
    ...CityType
  }
  departingDatetime
  arrivingDatetime
  duration
  carrier {
    ...CarrierType
  }
}
    ${CityTypeFragmentDoc}
${CarrierTypeFragmentDoc}`;
export const FlightClassTypeFragmentDoc = gql`
    fragment FlightClassType on FlightClassType {
  id
  name
}
    `;
export const RouteTypeFragmentDoc = gql`
    fragment RouteType on RouteType {
  id
  flight {
    ...FlightType
  }
  status
  kiuRbd
  meals
  flightClass {
    ...FlightClassType
  }
}
    ${FlightTypeFragmentDoc}
${FlightClassTypeFragmentDoc}`;
export const ItineraryTypeFragmentDoc = gql`
    fragment ItineraryType on ItineraryType {
  id
  itineraryNumber
  status
  draft
  approve
  verifiedPayment
  itineraryCreatedAt
  verificationCode
  downloadLink
  isDeleted
  isActive
  kiuBookingNumber
  canDownloadPdf
  qr
  pets {
    qty
    transportType
    transportTypeLabel
    routeType
    leg
  }
  passengers {
    ...ItineraryPassengerType
  }
  outboundFlights {
    ...RouteType
  }
  returnFlights {
    ...RouteType
  }
}
    ${ItineraryPassengerTypeFragmentDoc}
${RouteTypeFragmentDoc}`;
export const JobCategoryTypeFragmentDoc = gql`
    fragment JobCategoryType on JobCategoryType {
  id
  name
  description
  slug
  image {
    ...ImageType
  }
}
    ${ImageTypeFragmentDoc}`;
export const JobOfferTypeFragmentDoc = gql`
    fragment JobOfferType on JobOfferType {
  id
  name
  description
  workingTime
  workingMode
  location
  benefits
  functions
  skills
  category {
    ...JobCategoryType
  }
  slug
}
    ${JobCategoryTypeFragmentDoc}`;
export const KiuPriceTypeFragmentDoc = gql`
    fragment KIUPriceType on KIUPriceType {
  amount
  currency
}
    `;
export const KiuTaxTypeFragmentDoc = gql`
    fragment KIUTaxType on KIUTaxType {
  code
  price {
    ...KIUPriceType
  }
}
    ${KiuPriceTypeFragmentDoc}`;
export const KiuDateTypeFragmentDoc = gql`
    fragment KIUDateType on KIUDateType {
  date
  isValid
  routes {
    origin {
      ...CityType
    }
    destination {
      ...CityType
    }
    departingDatetime
    arrivingDatetime
    stopsQty
    isValid
    flights {
      departingDatetime
      arrivingDatetime
      stopQty
      flightNumber
      duration
      departingCity {
        ...CityType
      }
      arrivingCity {
        ...CityType
      }
      carrier {
        ...CarrierType
      }
      flightClasses {
        code
      }
    }
    errors
    airlines
    categories
    duration
  }
}
    ${CityTypeFragmentDoc}
${CarrierTypeFragmentDoc}`;
export const OfficeTypeFragmentDoc = gql`
    fragment OfficeType on OfficeType {
  id
  country {
    ...CountryType
  }
  address
  phone
  email
  schedule
  location {
    ...CoordinatePointType
  }
}
    ${CountryTypeFragmentDoc}
${CoordinatePointTypeFragmentDoc}`;
export const PageInfoTypeFragmentDoc = gql`
    fragment PageInfoType on PageInfoType {
  page
  pages
  hasNext
  hasPrev
  total
}
    `;
export const PassengerTypeFragmentDoc = gql`
    fragment PassengerType on PassengerType {
  id
  email
  birthDate
  passport
  phone
  fullName
}
    `;
export const SocialMediaTypeFragmentDoc = gql`
    fragment SocialMediaType on SocialMediaType {
  facebook
  instagram
  linkedin
  telegram
  pinterest
  youtube
}
    `;
export const WebMessageTypeFragmentDoc = gql`
    fragment WebMessageType on WebMessageType {
  id
  fromDate
  toDate
  subject
  message
  isActive
  messageType
  place
}
    `;
export const SignUpDocument = gql`
    mutation SignUp($firstName: String!, $lastName: String!, $email: String!, $password: String!, $subscribeNewsletter: Boolean, $acceptTerms: Boolean!, $recaptchaToken: String!, $callbackUrl: String) {
  signup(
    input: {firstName: $firstName, lastName: $lastName, email: $email, password: $password, subscribeNewsletter: $subscribeNewsletter, acceptTerms: $acceptTerms, recaptchaToken: $recaptchaToken, callbackUrl: $callbackUrl}
  ) {
    status
    errors {
      ...ErrorType
    }
    verificationToken
  }
}
    ${ErrorTypeFragmentDoc}`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      subscribeNewsletter: // value for 'subscribeNewsletter'
 *      acceptTerms: // value for 'acceptTerms'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      callbackUrl: // value for 'callbackUrl'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!, $recaptchaToken: String!) {
  login(email: $email, password: $password, recaptchaToken: $recaptchaToken) {
    status
    errors {
      ...ErrorType
    }
    response {
      ...AccessTokenType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${AccessTokenTypeFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const ForgotUserPasswordDocument = gql`
    mutation ForgotUserPassword($email: String!, $recaptchaToken: String!, $callbackUrl: String) {
  forgotPassword(
    email: $email
    recaptchaToken: $recaptchaToken
    callbackUrl: $callbackUrl
  ) {
    status
    errors {
      ...ErrorType
    }
  }
}
    ${ErrorTypeFragmentDoc}`;
export type ForgotUserPasswordMutationFn = Apollo.MutationFunction<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>;

/**
 * __useForgotUserPasswordMutation__
 *
 * To run a mutation, you first call `useForgotUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotUserPasswordMutation, { data, loading, error }] = useForgotUserPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      callbackUrl: // value for 'callbackUrl'
 *   },
 * });
 */
export function useForgotUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>(ForgotUserPasswordDocument, options);
      }
export type ForgotUserPasswordMutationHookResult = ReturnType<typeof useForgotUserPasswordMutation>;
export type ForgotUserPasswordMutationResult = Apollo.MutationResult<ForgotUserPasswordMutation>;
export type ForgotUserPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>;
export const RecoverPasswordDocument = gql`
    mutation RecoverPassword($email: String!, $password: String!, $token: String!) {
  recoverPassword(email: $email, password: $password, token: $token) {
    status
    errors {
      ...ErrorType
    }
    response {
      ...AccessTokenType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${AccessTokenTypeFragmentDoc}`;
export type RecoverPasswordMutationFn = Apollo.MutationFunction<RecoverPasswordMutation, RecoverPasswordMutationVariables>;

/**
 * __useRecoverPasswordMutation__
 *
 * To run a mutation, you first call `useRecoverPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverPasswordMutation, { data, loading, error }] = useRecoverPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRecoverPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RecoverPasswordMutation, RecoverPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverPasswordMutation, RecoverPasswordMutationVariables>(RecoverPasswordDocument, options);
      }
export type RecoverPasswordMutationHookResult = ReturnType<typeof useRecoverPasswordMutation>;
export type RecoverPasswordMutationResult = Apollo.MutationResult<RecoverPasswordMutation>;
export type RecoverPasswordMutationOptions = Apollo.BaseMutationOptions<RecoverPasswordMutation, RecoverPasswordMutationVariables>;
export const VerifyAccountDocument = gql`
    mutation VerifyAccount($email: String!, $token: String!) {
  verifyAccount(email: $email, token: $token) {
    status
    errors {
      ...ErrorType
    }
    response {
      ...AccessTokenType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${AccessTokenTypeFragmentDoc}`;
export type VerifyAccountMutationFn = Apollo.MutationFunction<VerifyAccountMutation, VerifyAccountMutationVariables>;

/**
 * __useVerifyAccountMutation__
 *
 * To run a mutation, you first call `useVerifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccountMutation, { data, loading, error }] = useVerifyAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyAccountMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAccountMutation, VerifyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAccountMutation, VerifyAccountMutationVariables>(VerifyAccountDocument, options);
      }
export type VerifyAccountMutationHookResult = ReturnType<typeof useVerifyAccountMutation>;
export type VerifyAccountMutationResult = Apollo.MutationResult<VerifyAccountMutation>;
export type VerifyAccountMutationOptions = Apollo.BaseMutationOptions<VerifyAccountMutation, VerifyAccountMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($firstName: String!, $lastName: String!, $country: ID, $email: String!, $phone: String, $image: Upload, $birthday: Date, $passport: String, $passportExpireAt: Date, $passportEmittedAt: Date, $passportEmissionCountry: ID, $callbackUrl: String) {
  updateProfile(
    input: {firstName: $firstName, lastName: $lastName, country: $country, email: $email, phone: $phone, image: $image, birthday: $birthday, passport: $passport, passportExpireAt: $passportExpireAt, passportEmittedAt: $passportEmittedAt, passportEmissionCountry: $passportEmissionCountry, callbackUrl: $callbackUrl}
  ) {
    status
    errors {
      ...ErrorType
    }
    user {
      ...UserType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${UserTypeFragmentDoc}`;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      country: // value for 'country'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      image: // value for 'image'
 *      birthday: // value for 'birthday'
 *      passport: // value for 'passport'
 *      passportExpireAt: // value for 'passportExpireAt'
 *      passportEmittedAt: // value for 'passportEmittedAt'
 *      passportEmissionCountry: // value for 'passportEmissionCountry'
 *      callbackUrl: // value for 'callbackUrl'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const VerifyNewEmailDocument = gql`
    mutation VerifyNewEmail($email: String!, $token: String!) {
  verifyNewEmail(email: $email, token: $token) {
    status
    errors {
      ...ErrorType
    }
    response {
      ...AccessTokenType
    }
    user {
      ...UserType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${AccessTokenTypeFragmentDoc}
${UserTypeFragmentDoc}`;
export type VerifyNewEmailMutationFn = Apollo.MutationFunction<VerifyNewEmailMutation, VerifyNewEmailMutationVariables>;

/**
 * __useVerifyNewEmailMutation__
 *
 * To run a mutation, you first call `useVerifyNewEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyNewEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyNewEmailMutation, { data, loading, error }] = useVerifyNewEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyNewEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyNewEmailMutation, VerifyNewEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyNewEmailMutation, VerifyNewEmailMutationVariables>(VerifyNewEmailDocument, options);
      }
export type VerifyNewEmailMutationHookResult = ReturnType<typeof useVerifyNewEmailMutation>;
export type VerifyNewEmailMutationResult = Apollo.MutationResult<VerifyNewEmailMutation>;
export type VerifyNewEmailMutationOptions = Apollo.BaseMutationOptions<VerifyNewEmailMutation, VerifyNewEmailMutationVariables>;
export const SendContactUsDocument = gql`
    mutation SendContactUs($name: String!, $email: String!, $subject: String!, $message: String!, $recaptchaToken: String!) {
  sendContactMessage(
    input: {name: $name, email: $email, subject: $subject, message: $message}
    recaptchaToken: $recaptchaToken
  ) {
    status
    errors {
      ...ErrorType
    }
    contactMessage {
      name
      email
      subject
      message
      sent
      createdAt
    }
  }
}
    ${ErrorTypeFragmentDoc}`;
export type SendContactUsMutationFn = Apollo.MutationFunction<SendContactUsMutation, SendContactUsMutationVariables>;

/**
 * __useSendContactUsMutation__
 *
 * To run a mutation, you first call `useSendContactUsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactUsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactUsMutation, { data, loading, error }] = useSendContactUsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useSendContactUsMutation(baseOptions?: Apollo.MutationHookOptions<SendContactUsMutation, SendContactUsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactUsMutation, SendContactUsMutationVariables>(SendContactUsDocument, options);
      }
export type SendContactUsMutationHookResult = ReturnType<typeof useSendContactUsMutation>;
export type SendContactUsMutationResult = Apollo.MutationResult<SendContactUsMutation>;
export type SendContactUsMutationOptions = Apollo.BaseMutationOptions<SendContactUsMutation, SendContactUsMutationVariables>;
export const KiuReserveFlightsDocument = gql`
    mutation KiuReserveFlights($input: String!) {
  kiuReserveFlights(input: $input) {
    status
    errors {
      ...ErrorType
    }
    customErrors {
      field
      messages
      code
    }
    itinerary {
      ...ItineraryType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${ItineraryTypeFragmentDoc}`;
export type KiuReserveFlightsMutationFn = Apollo.MutationFunction<KiuReserveFlightsMutation, KiuReserveFlightsMutationVariables>;

/**
 * __useKiuReserveFlightsMutation__
 *
 * To run a mutation, you first call `useKiuReserveFlightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKiuReserveFlightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kiuReserveFlightsMutation, { data, loading, error }] = useKiuReserveFlightsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKiuReserveFlightsMutation(baseOptions?: Apollo.MutationHookOptions<KiuReserveFlightsMutation, KiuReserveFlightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KiuReserveFlightsMutation, KiuReserveFlightsMutationVariables>(KiuReserveFlightsDocument, options);
      }
export type KiuReserveFlightsMutationHookResult = ReturnType<typeof useKiuReserveFlightsMutation>;
export type KiuReserveFlightsMutationResult = Apollo.MutationResult<KiuReserveFlightsMutation>;
export type KiuReserveFlightsMutationOptions = Apollo.BaseMutationOptions<KiuReserveFlightsMutation, KiuReserveFlightsMutationVariables>;
export const KiuPassengerFormDocument = gql`
    mutation KiuPassengerForm($input: KIUPassengerFormInput!) {
  kiuPassengerForm(input: $input) {
    status
    errors {
      ...ErrorType
    }
    response
  }
}
    ${ErrorTypeFragmentDoc}`;
export type KiuPassengerFormMutationFn = Apollo.MutationFunction<KiuPassengerFormMutation, KiuPassengerFormMutationVariables>;

/**
 * __useKiuPassengerFormMutation__
 *
 * To run a mutation, you first call `useKiuPassengerFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKiuPassengerFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kiuPassengerFormMutation, { data, loading, error }] = useKiuPassengerFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKiuPassengerFormMutation(baseOptions?: Apollo.MutationHookOptions<KiuPassengerFormMutation, KiuPassengerFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KiuPassengerFormMutation, KiuPassengerFormMutationVariables>(KiuPassengerFormDocument, options);
      }
export type KiuPassengerFormMutationHookResult = ReturnType<typeof useKiuPassengerFormMutation>;
export type KiuPassengerFormMutationResult = Apollo.MutationResult<KiuPassengerFormMutation>;
export type KiuPassengerFormMutationOptions = Apollo.BaseMutationOptions<KiuPassengerFormMutation, KiuPassengerFormMutationVariables>;
export const JobOfferApplyDocument = gql`
    mutation JobOfferApply($jobOffer: ID!, $firstName: String!, $lastName: String!, $email: String!, $phone: String!, $address: String!, $country: ID!, $linkedinProfile: String, $curriculum: Upload!, $reason: String, $expectedPayment: String, $recaptchaToken: String) {
  jobRequest(
    input: {jobOffer: $jobOffer, firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, address: $address, country: $country, linkedinProfile: $linkedinProfile, curriculum: $curriculum, reason: $reason, expectedPayment: $expectedPayment}
    recaptchaToken: $recaptchaToken
  ) {
    status
    errors {
      ...ErrorType
    }
  }
}
    ${ErrorTypeFragmentDoc}`;
export type JobOfferApplyMutationFn = Apollo.MutationFunction<JobOfferApplyMutation, JobOfferApplyMutationVariables>;

/**
 * __useJobOfferApplyMutation__
 *
 * To run a mutation, you first call `useJobOfferApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobOfferApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobOfferApplyMutation, { data, loading, error }] = useJobOfferApplyMutation({
 *   variables: {
 *      jobOffer: // value for 'jobOffer'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      address: // value for 'address'
 *      country: // value for 'country'
 *      linkedinProfile: // value for 'linkedinProfile'
 *      curriculum: // value for 'curriculum'
 *      reason: // value for 'reason'
 *      expectedPayment: // value for 'expectedPayment'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useJobOfferApplyMutation(baseOptions?: Apollo.MutationHookOptions<JobOfferApplyMutation, JobOfferApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobOfferApplyMutation, JobOfferApplyMutationVariables>(JobOfferApplyDocument, options);
      }
export type JobOfferApplyMutationHookResult = ReturnType<typeof useJobOfferApplyMutation>;
export type JobOfferApplyMutationResult = Apollo.MutationResult<JobOfferApplyMutation>;
export type JobOfferApplyMutationOptions = Apollo.BaseMutationOptions<JobOfferApplyMutation, JobOfferApplyMutationVariables>;
export const SubscribeDocument = gql`
    mutation Subscribe($fullName: String!, $email: String!, $recaptchaToken: String!) {
  subscribe(
    input: {fullName: $fullName, email: $email}
    recaptchaToken: $recaptchaToken
  ) {
    status
    errors {
      ...ErrorType
    }
  }
}
    ${ErrorTypeFragmentDoc}`;
export type SubscribeMutationFn = Apollo.MutationFunction<SubscribeMutation, SubscribeMutationVariables>;

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      fullName: // value for 'fullName'
 *      email: // value for 'email'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeMutation, SubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeMutation, SubscribeMutationVariables>(SubscribeDocument, options);
      }
export type SubscribeMutationHookResult = ReturnType<typeof useSubscribeMutation>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<SubscribeMutation, SubscribeMutationVariables>;
export const UnsubscribeDocument = gql`
    mutation Unsubscribe($email: String!) {
  unsubscribe(email: $email) {
    status
    errors {
      ...ErrorType
    }
  }
}
    ${ErrorTypeFragmentDoc}`;
export type UnsubscribeMutationFn = Apollo.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;

/**
 * __useUnsubscribeMutation__
 *
 * To run a mutation, you first call `useUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeMutation, { data, loading, error }] = useUnsubscribeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeMutation, UnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, options);
      }
export type UnsubscribeMutationHookResult = ReturnType<typeof useUnsubscribeMutation>;
export type UnsubscribeMutationResult = Apollo.MutationResult<UnsubscribeMutation>;
export type UnsubscribeMutationOptions = Apollo.BaseMutationOptions<UnsubscribeMutation, UnsubscribeMutationVariables>;
export const AdvertisingDocument = gql`
    query Advertising($skip: Int, $take: Int, $report: Boolean) {
  advertisings(skip: $skip, take: $take, report: $report) {
    status
    errors {
      ...ErrorType
    }
    pageInfo {
      ...PageInfoType
    }
    objects {
      id
      name
      image {
        ...ImageType
      }
      description
      begin
      end
      facebookLink
      instagramLink
    }
  }
}
    ${ErrorTypeFragmentDoc}
${PageInfoTypeFragmentDoc}
${ImageTypeFragmentDoc}`;

/**
 * __useAdvertisingQuery__
 *
 * To run a query within a React component, call `useAdvertisingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertisingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertisingQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      report: // value for 'report'
 *   },
 * });
 */
export function useAdvertisingQuery(baseOptions?: Apollo.QueryHookOptions<AdvertisingQuery, AdvertisingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvertisingQuery, AdvertisingQueryVariables>(AdvertisingDocument, options);
      }
export function useAdvertisingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvertisingQuery, AdvertisingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvertisingQuery, AdvertisingQueryVariables>(AdvertisingDocument, options);
        }
export type AdvertisingQueryHookResult = ReturnType<typeof useAdvertisingQuery>;
export type AdvertisingLazyQueryHookResult = ReturnType<typeof useAdvertisingLazyQuery>;
export type AdvertisingQueryResult = Apollo.QueryResult<AdvertisingQuery, AdvertisingQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    status
    errors {
      ...ErrorType
    }
    object {
      ...UserType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${UserTypeFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const VerifyForgotPasswordDocument = gql`
    query VerifyForgotPassword($email: String!, $token: String!) {
  verifyForgotPassword(token: $token, email: $email) {
    isValid
  }
}
    `;

/**
 * __useVerifyForgotPasswordQuery__
 *
 * To run a query within a React component, call `useVerifyForgotPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyForgotPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyForgotPasswordQuery({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyForgotPasswordQuery(baseOptions: Apollo.QueryHookOptions<VerifyForgotPasswordQuery, VerifyForgotPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyForgotPasswordQuery, VerifyForgotPasswordQueryVariables>(VerifyForgotPasswordDocument, options);
      }
export function useVerifyForgotPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyForgotPasswordQuery, VerifyForgotPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyForgotPasswordQuery, VerifyForgotPasswordQueryVariables>(VerifyForgotPasswordDocument, options);
        }
export type VerifyForgotPasswordQueryHookResult = ReturnType<typeof useVerifyForgotPasswordQuery>;
export type VerifyForgotPasswordLazyQueryHookResult = ReturnType<typeof useVerifyForgotPasswordLazyQuery>;
export type VerifyForgotPasswordQueryResult = Apollo.QueryResult<VerifyForgotPasswordQuery, VerifyForgotPasswordQueryVariables>;
export const ContactCardInfoDocument = gql`
    query ContactCardInfo($token: String!) {
  contactCardInfo(token: $token) {
    status
    errors {
      ...ErrorType
    }
    object {
      id
      fullName
      email
      phoneStaff
      agency
      image {
        ...ImageType
      }
    }
  }
}
    ${ErrorTypeFragmentDoc}
${ImageTypeFragmentDoc}`;

/**
 * __useContactCardInfoQuery__
 *
 * To run a query within a React component, call `useContactCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCardInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useContactCardInfoQuery(baseOptions: Apollo.QueryHookOptions<ContactCardInfoQuery, ContactCardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCardInfoQuery, ContactCardInfoQueryVariables>(ContactCardInfoDocument, options);
      }
export function useContactCardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCardInfoQuery, ContactCardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCardInfoQuery, ContactCardInfoQueryVariables>(ContactCardInfoDocument, options);
        }
export type ContactCardInfoQueryHookResult = ReturnType<typeof useContactCardInfoQuery>;
export type ContactCardInfoLazyQueryHookResult = ReturnType<typeof useContactCardInfoLazyQuery>;
export type ContactCardInfoQueryResult = Apollo.QueryResult<ContactCardInfoQuery, ContactCardInfoQueryVariables>;
export const CitiesDocument = gql`
    query Cities($skip: Int, $take: Int, $report: Boolean) {
  cities(report: $report, skip: $skip, take: $take) {
    status
    pageInfo {
      ...PageInfoType
    }
    errors {
      ...ErrorType
    }
    objects {
      ...CityType
    }
  }
}
    ${PageInfoTypeFragmentDoc}
${ErrorTypeFragmentDoc}
${CityTypeFragmentDoc}`;

/**
 * __useCitiesQuery__
 *
 * To run a query within a React component, call `useCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitiesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      report: // value for 'report'
 *   },
 * });
 */
export function useCitiesQuery(baseOptions?: Apollo.QueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
      }
export function useCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
        }
export type CitiesQueryHookResult = ReturnType<typeof useCitiesQuery>;
export type CitiesLazyQueryHookResult = ReturnType<typeof useCitiesLazyQuery>;
export type CitiesQueryResult = Apollo.QueryResult<CitiesQuery, CitiesQueryVariables>;
export const CountriesDocument = gql`
    query Countries($skip: Int, $take: Int, $report: Boolean) {
  countries(report: $report, skip: $skip, take: $take) {
    status
    errors {
      ...ErrorType
    }
    objects {
      ...CountryType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${CountryTypeFragmentDoc}`;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      report: // value for 'report'
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const DestinationsDocument = gql`
    query Destinations($skip: Int, $take: Int, $report: Boolean) {
  destinations(skip: $skip, take: $take, report: $report) {
    status
    errors {
      ...ErrorType
    }
    objects {
      ...DestinationType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${DestinationTypeFragmentDoc}`;

/**
 * __useDestinationsQuery__
 *
 * To run a query within a React component, call `useDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      report: // value for 'report'
 *   },
 * });
 */
export function useDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, options);
      }
export function useDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, options);
        }
export type DestinationsQueryHookResult = ReturnType<typeof useDestinationsQuery>;
export type DestinationsLazyQueryHookResult = ReturnType<typeof useDestinationsLazyQuery>;
export type DestinationsQueryResult = Apollo.QueryResult<DestinationsQuery, DestinationsQueryVariables>;
export const DestinationBySlugDocument = gql`
    query DestinationBySlug($slug: String!) {
  destinationBySlug(slug: $slug) {
    status
    errors {
      ...ErrorType
    }
    object {
      ...DestinationType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${DestinationTypeFragmentDoc}`;

/**
 * __useDestinationBySlugQuery__
 *
 * To run a query within a React component, call `useDestinationBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useDestinationBySlugQuery(baseOptions: Apollo.QueryHookOptions<DestinationBySlugQuery, DestinationBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationBySlugQuery, DestinationBySlugQueryVariables>(DestinationBySlugDocument, options);
      }
export function useDestinationBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationBySlugQuery, DestinationBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationBySlugQuery, DestinationBySlugQueryVariables>(DestinationBySlugDocument, options);
        }
export type DestinationBySlugQueryHookResult = ReturnType<typeof useDestinationBySlugQuery>;
export type DestinationBySlugLazyQueryHookResult = ReturnType<typeof useDestinationBySlugLazyQuery>;
export type DestinationBySlugQueryResult = Apollo.QueryResult<DestinationBySlugQuery, DestinationBySlugQueryVariables>;
export const DestinationsMostPopularsDocument = gql`
    query DestinationsMostPopulars($size: Int) {
  destinationsMostPopulars(size: $size) {
    status
    errors {
      ...ErrorType
    }
    objects {
      ...DestinationType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${DestinationTypeFragmentDoc}`;

/**
 * __useDestinationsMostPopularsQuery__
 *
 * To run a query within a React component, call `useDestinationsMostPopularsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsMostPopularsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsMostPopularsQuery({
 *   variables: {
 *      size: // value for 'size'
 *   },
 * });
 */
export function useDestinationsMostPopularsQuery(baseOptions?: Apollo.QueryHookOptions<DestinationsMostPopularsQuery, DestinationsMostPopularsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationsMostPopularsQuery, DestinationsMostPopularsQueryVariables>(DestinationsMostPopularsDocument, options);
      }
export function useDestinationsMostPopularsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsMostPopularsQuery, DestinationsMostPopularsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationsMostPopularsQuery, DestinationsMostPopularsQueryVariables>(DestinationsMostPopularsDocument, options);
        }
export type DestinationsMostPopularsQueryHookResult = ReturnType<typeof useDestinationsMostPopularsQuery>;
export type DestinationsMostPopularsLazyQueryHookResult = ReturnType<typeof useDestinationsMostPopularsLazyQuery>;
export type DestinationsMostPopularsQueryResult = Apollo.QueryResult<DestinationsMostPopularsQuery, DestinationsMostPopularsQueryVariables>;
export const MomentDestinationsDocument = gql`
    query MomentDestinations {
  momentDestinations {
    status
    errors {
      ...ErrorType
    }
    objects {
      ...DestinationType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${DestinationTypeFragmentDoc}`;

/**
 * __useMomentDestinationsQuery__
 *
 * To run a query within a React component, call `useMomentDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMomentDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMomentDestinationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMomentDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<MomentDestinationsQuery, MomentDestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MomentDestinationsQuery, MomentDestinationsQueryVariables>(MomentDestinationsDocument, options);
      }
export function useMomentDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MomentDestinationsQuery, MomentDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MomentDestinationsQuery, MomentDestinationsQueryVariables>(MomentDestinationsDocument, options);
        }
export type MomentDestinationsQueryHookResult = ReturnType<typeof useMomentDestinationsQuery>;
export type MomentDestinationsLazyQueryHookResult = ReturnType<typeof useMomentDestinationsLazyQuery>;
export type MomentDestinationsQueryResult = Apollo.QueryResult<MomentDestinationsQuery, MomentDestinationsQueryVariables>;
export const DestinationsRecentlyDocument = gql`
    query DestinationsRecently($size: Int) {
  destinationsRecently(size: $size) {
    status
    errors {
      ...ErrorType
    }
    objects {
      ...DestinationType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${DestinationTypeFragmentDoc}`;

/**
 * __useDestinationsRecentlyQuery__
 *
 * To run a query within a React component, call `useDestinationsRecentlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsRecentlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsRecentlyQuery({
 *   variables: {
 *      size: // value for 'size'
 *   },
 * });
 */
export function useDestinationsRecentlyQuery(baseOptions?: Apollo.QueryHookOptions<DestinationsRecentlyQuery, DestinationsRecentlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationsRecentlyQuery, DestinationsRecentlyQueryVariables>(DestinationsRecentlyDocument, options);
      }
export function useDestinationsRecentlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsRecentlyQuery, DestinationsRecentlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationsRecentlyQuery, DestinationsRecentlyQueryVariables>(DestinationsRecentlyDocument, options);
        }
export type DestinationsRecentlyQueryHookResult = ReturnType<typeof useDestinationsRecentlyQuery>;
export type DestinationsRecentlyLazyQueryHookResult = ReturnType<typeof useDestinationsRecentlyLazyQuery>;
export type DestinationsRecentlyQueryResult = Apollo.QueryResult<DestinationsRecentlyQuery, DestinationsRecentlyQueryVariables>;
export const FaqsDocument = gql`
    query Faqs($skip: Int, $take: Int, $report: Boolean, $searchFields: [FAQSearchFieldInput], $sortFields: FAQSortFieldInput) {
  faqs(
    report: $report
    skip: $skip
    take: $take
    searchFields: $searchFields
    sortFields: $sortFields
  ) {
    status
    errors {
      ...ErrorType
    }
    pageInfo {
      ...PageInfoType
    }
    objects {
      id
      question
      response
    }
  }
}
    ${ErrorTypeFragmentDoc}
${PageInfoTypeFragmentDoc}`;

/**
 * __useFaqsQuery__
 *
 * To run a query within a React component, call `useFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      report: // value for 'report'
 *      searchFields: // value for 'searchFields'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useFaqsQuery(baseOptions?: Apollo.QueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, options);
      }
export function useFaqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, options);
        }
export type FaqsQueryHookResult = ReturnType<typeof useFaqsQuery>;
export type FaqsLazyQueryHookResult = ReturnType<typeof useFaqsLazyQuery>;
export type FaqsQueryResult = Apollo.QueryResult<FaqsQuery, FaqsQueryVariables>;
export const FindItineraryDocument = gql`
    query FindItinerary($locator: String!, $passport: String!, $recaptchaToken: String) {
  findItinerary(
    locator: $locator
    passport: $passport
    recaptchaToken: $recaptchaToken
  ) {
    status
    errors {
      ...ErrorType
    }
    object {
      ...ItineraryType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${ItineraryTypeFragmentDoc}`;

/**
 * __useFindItineraryQuery__
 *
 * To run a query within a React component, call `useFindItineraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindItineraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindItineraryQuery({
 *   variables: {
 *      locator: // value for 'locator'
 *      passport: // value for 'passport'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useFindItineraryQuery(baseOptions: Apollo.QueryHookOptions<FindItineraryQuery, FindItineraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindItineraryQuery, FindItineraryQueryVariables>(FindItineraryDocument, options);
      }
export function useFindItineraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindItineraryQuery, FindItineraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindItineraryQuery, FindItineraryQueryVariables>(FindItineraryDocument, options);
        }
export type FindItineraryQueryHookResult = ReturnType<typeof useFindItineraryQuery>;
export type FindItineraryLazyQueryHookResult = ReturnType<typeof useFindItineraryLazyQuery>;
export type FindItineraryQueryResult = Apollo.QueryResult<FindItineraryQuery, FindItineraryQueryVariables>;
export const JobOffersDocument = gql`
    query JobOffers($skip: Int, $take: Int, $report: Boolean) {
  jobOffers(report: $report, skip: $skip, take: $take) {
    status
    errors {
      ...ErrorType
    }
    objects {
      ...JobOfferType
    }
    pageInfo {
      ...PageInfoType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${JobOfferTypeFragmentDoc}
${PageInfoTypeFragmentDoc}`;

/**
 * __useJobOffersQuery__
 *
 * To run a query within a React component, call `useJobOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobOffersQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      report: // value for 'report'
 *   },
 * });
 */
export function useJobOffersQuery(baseOptions?: Apollo.QueryHookOptions<JobOffersQuery, JobOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobOffersQuery, JobOffersQueryVariables>(JobOffersDocument, options);
      }
export function useJobOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobOffersQuery, JobOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobOffersQuery, JobOffersQueryVariables>(JobOffersDocument, options);
        }
export type JobOffersQueryHookResult = ReturnType<typeof useJobOffersQuery>;
export type JobOffersLazyQueryHookResult = ReturnType<typeof useJobOffersLazyQuery>;
export type JobOffersQueryResult = Apollo.QueryResult<JobOffersQuery, JobOffersQueryVariables>;
export const JobOfferBySlugDocument = gql`
    query JobOfferBySlug($slug: String!) {
  jobOfferBySlug(slug: $slug) {
    status
    errors {
      ...ErrorType
    }
    object {
      ...JobOfferType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${JobOfferTypeFragmentDoc}`;

/**
 * __useJobOfferBySlugQuery__
 *
 * To run a query within a React component, call `useJobOfferBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobOfferBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobOfferBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useJobOfferBySlugQuery(baseOptions: Apollo.QueryHookOptions<JobOfferBySlugQuery, JobOfferBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobOfferBySlugQuery, JobOfferBySlugQueryVariables>(JobOfferBySlugDocument, options);
      }
export function useJobOfferBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobOfferBySlugQuery, JobOfferBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobOfferBySlugQuery, JobOfferBySlugQueryVariables>(JobOfferBySlugDocument, options);
        }
export type JobOfferBySlugQueryHookResult = ReturnType<typeof useJobOfferBySlugQuery>;
export type JobOfferBySlugLazyQueryHookResult = ReturnType<typeof useJobOfferBySlugLazyQuery>;
export type JobOfferBySlugQueryResult = Apollo.QueryResult<JobOfferBySlugQuery, JobOfferBySlugQueryVariables>;
export const KiuGetAvailabilityDocument = gql`
    query KiuGetAvailability($originLocationCode: String!, $destinationLocationCode: String!, $cabin: CabinTypesEnum, $maxStopsQty: Int, $airlineCode: String, $departureDate: Date!, $returnDate: Date, $directFlightsOnly: Boolean!, $maxResponses: Int, $combinedItineraries: Boolean, $isRoundTrip: Boolean, $isFlexibleDates: Boolean, $passengersQty: [PassengerQtyType]!, $returnLocationCode: String) {
  kiuGetAvailability(
    params: {originLocationCode: $originLocationCode, destinationLocationCode: $destinationLocationCode, cabin: $cabin, maxStopsQty: $maxStopsQty, airlineCode: $airlineCode, departureDate: $departureDate, returnDate: $returnDate, directFlightsOnly: $directFlightsOnly, maxResponses: $maxResponses, combinedItineraries: $combinedItineraries, isRoundTrip: $isRoundTrip, isFlexibleDates: $isFlexibleDates, passengersQty: $passengersQty, returnLocationCode: $returnLocationCode}
  ) {
    status
    errors {
      field
      messages
    }
    response {
      routeType
      originCity {
        ...CityType
      }
      destinationCity {
        ...CityType
      }
      returnCity {
        ...CityType
      }
      departingDate
      returnDate
      adults
      children
      passengersQty
      outboundRoutes {
        ...KIUDateType
      }
      returnRoutes {
        ...KIUDateType
      }
      invalidCities
    }
  }
}
    ${CityTypeFragmentDoc}
${KiuDateTypeFragmentDoc}`;

/**
 * __useKiuGetAvailabilityQuery__
 *
 * To run a query within a React component, call `useKiuGetAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useKiuGetAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKiuGetAvailabilityQuery({
 *   variables: {
 *      originLocationCode: // value for 'originLocationCode'
 *      destinationLocationCode: // value for 'destinationLocationCode'
 *      cabin: // value for 'cabin'
 *      maxStopsQty: // value for 'maxStopsQty'
 *      airlineCode: // value for 'airlineCode'
 *      departureDate: // value for 'departureDate'
 *      returnDate: // value for 'returnDate'
 *      directFlightsOnly: // value for 'directFlightsOnly'
 *      maxResponses: // value for 'maxResponses'
 *      combinedItineraries: // value for 'combinedItineraries'
 *      isRoundTrip: // value for 'isRoundTrip'
 *      isFlexibleDates: // value for 'isFlexibleDates'
 *      passengersQty: // value for 'passengersQty'
 *      returnLocationCode: // value for 'returnLocationCode'
 *   },
 * });
 */
export function useKiuGetAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<KiuGetAvailabilityQuery, KiuGetAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KiuGetAvailabilityQuery, KiuGetAvailabilityQueryVariables>(KiuGetAvailabilityDocument, options);
      }
export function useKiuGetAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KiuGetAvailabilityQuery, KiuGetAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KiuGetAvailabilityQuery, KiuGetAvailabilityQueryVariables>(KiuGetAvailabilityDocument, options);
        }
export type KiuGetAvailabilityQueryHookResult = ReturnType<typeof useKiuGetAvailabilityQuery>;
export type KiuGetAvailabilityLazyQueryHookResult = ReturnType<typeof useKiuGetAvailabilityLazyQuery>;
export type KiuGetAvailabilityQueryResult = Apollo.QueryResult<KiuGetAvailabilityQuery, KiuGetAvailabilityQueryVariables>;
export const KiuGetPricesDocument = gql`
    query KiuGetPrices($outboundDepartureDatetimes: [DateTime]!, $outboundArrivalDatetimes: [DateTime]!, $outboundFlightNumbers: [String]!, $outboundResBookDesigCodes: [String]!, $outboundAirlineCodes: [String]!, $outboundOriginLocationCodes: [String]!, $outboundDestinationLocationCodes: [String]!, $returnDepartureDatetimes: [DateTime]!, $returnArrivalDatetimes: [DateTime]!, $returnFlightNumbers: [String]!, $returnResBookDesigCodes: [String]!, $returnAirlineCodes: [String]!, $returnOriginLocationCodes: [String]!, $returnDestinationLocationCodes: [String]!, $passengersQty: [PassengerQtyType]!) {
  kiuGetPrices(
    params: {outboundDepartureDatetimes: $outboundDepartureDatetimes, outboundArrivalDatetimes: $outboundArrivalDatetimes, outboundFlightNumbers: $outboundFlightNumbers, outboundResBookDesigCodes: $outboundResBookDesigCodes, outboundAirlineCodes: $outboundAirlineCodes, outboundOriginLocationCodes: $outboundOriginLocationCodes, outboundDestinationLocationCodes: $outboundDestinationLocationCodes, returnDepartureDatetimes: $returnDepartureDatetimes, returnArrivalDatetimes: $returnArrivalDatetimes, returnFlightNumbers: $returnFlightNumbers, returnResBookDesigCodes: $returnResBookDesigCodes, returnAirlineCodes: $returnAirlineCodes, returnOriginLocationCodes: $returnOriginLocationCodes, returnDestinationLocationCodes: $returnDestinationLocationCodes, passengersQty: $passengersQty}
  ) {
    status
    errors {
      messages
      field
    }
    response {
      baseFare {
        ...KIUPriceType
      }
      equivFare {
        ...KIUPriceType
      }
      taxes {
        ...KIUTaxType
      }
      totalFare {
        ...KIUPriceType
      }
      totalTaxes {
        ...KIUPriceType
      }
      fee {
        ...KIUPriceType
      }
      totalGds {
        ...KIUPriceType
      }
      total {
        ...KIUPriceType
      }
    }
  }
}
    ${KiuPriceTypeFragmentDoc}
${KiuTaxTypeFragmentDoc}`;

/**
 * __useKiuGetPricesQuery__
 *
 * To run a query within a React component, call `useKiuGetPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKiuGetPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKiuGetPricesQuery({
 *   variables: {
 *      outboundDepartureDatetimes: // value for 'outboundDepartureDatetimes'
 *      outboundArrivalDatetimes: // value for 'outboundArrivalDatetimes'
 *      outboundFlightNumbers: // value for 'outboundFlightNumbers'
 *      outboundResBookDesigCodes: // value for 'outboundResBookDesigCodes'
 *      outboundAirlineCodes: // value for 'outboundAirlineCodes'
 *      outboundOriginLocationCodes: // value for 'outboundOriginLocationCodes'
 *      outboundDestinationLocationCodes: // value for 'outboundDestinationLocationCodes'
 *      returnDepartureDatetimes: // value for 'returnDepartureDatetimes'
 *      returnArrivalDatetimes: // value for 'returnArrivalDatetimes'
 *      returnFlightNumbers: // value for 'returnFlightNumbers'
 *      returnResBookDesigCodes: // value for 'returnResBookDesigCodes'
 *      returnAirlineCodes: // value for 'returnAirlineCodes'
 *      returnOriginLocationCodes: // value for 'returnOriginLocationCodes'
 *      returnDestinationLocationCodes: // value for 'returnDestinationLocationCodes'
 *      passengersQty: // value for 'passengersQty'
 *   },
 * });
 */
export function useKiuGetPricesQuery(baseOptions: Apollo.QueryHookOptions<KiuGetPricesQuery, KiuGetPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KiuGetPricesQuery, KiuGetPricesQueryVariables>(KiuGetPricesDocument, options);
      }
export function useKiuGetPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KiuGetPricesQuery, KiuGetPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KiuGetPricesQuery, KiuGetPricesQueryVariables>(KiuGetPricesDocument, options);
        }
export type KiuGetPricesQueryHookResult = ReturnType<typeof useKiuGetPricesQuery>;
export type KiuGetPricesLazyQueryHookResult = ReturnType<typeof useKiuGetPricesLazyQuery>;
export type KiuGetPricesQueryResult = Apollo.QueryResult<KiuGetPricesQuery, KiuGetPricesQueryVariables>;
export const OfficesDocument = gql`
    query Offices {
  offices {
    status
    pageInfo {
      ...PageInfoType
    }
    errors {
      ...ErrorType
    }
    objects {
      ...OfficeType
    }
  }
}
    ${PageInfoTypeFragmentDoc}
${ErrorTypeFragmentDoc}
${OfficeTypeFragmentDoc}`;

/**
 * __useOfficesQuery__
 *
 * To run a query within a React component, call `useOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfficesQuery(baseOptions?: Apollo.QueryHookOptions<OfficesQuery, OfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficesQuery, OfficesQueryVariables>(OfficesDocument, options);
      }
export function useOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficesQuery, OfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficesQuery, OfficesQueryVariables>(OfficesDocument, options);
        }
export type OfficesQueryHookResult = ReturnType<typeof useOfficesQuery>;
export type OfficesLazyQueryHookResult = ReturnType<typeof useOfficesLazyQuery>;
export type OfficesQueryResult = Apollo.QueryResult<OfficesQuery, OfficesQueryVariables>;
export const PackagesDocument = gql`
    query Packages($skip: Int, $take: Int, $report: Boolean) {
  packages(report: $report, skip: $skip, take: $take) {
    status
    errors {
      ...ErrorType
    }
    pageInfo {
      ...PageInfoType
    }
    objects {
      ...TouristPackageObjectType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${PageInfoTypeFragmentDoc}
${TouristPackageObjectTypeFragmentDoc}`;

/**
 * __usePackagesQuery__
 *
 * To run a query within a React component, call `usePackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      report: // value for 'report'
 *   },
 * });
 */
export function usePackagesQuery(baseOptions?: Apollo.QueryHookOptions<PackagesQuery, PackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagesQuery, PackagesQueryVariables>(PackagesDocument, options);
      }
export function usePackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagesQuery, PackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagesQuery, PackagesQueryVariables>(PackagesDocument, options);
        }
export type PackagesQueryHookResult = ReturnType<typeof usePackagesQuery>;
export type PackagesLazyQueryHookResult = ReturnType<typeof usePackagesLazyQuery>;
export type PackagesQueryResult = Apollo.QueryResult<PackagesQuery, PackagesQueryVariables>;
export const PackageByIdDocument = gql`
    query PackageById($id: ID!) {
  packageById(id: $id) {
    status
    errors {
      ...ErrorType
    }
    object {
      ...TouristPackageObjectType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${TouristPackageObjectTypeFragmentDoc}`;

/**
 * __usePackageByIdQuery__
 *
 * To run a query within a React component, call `usePackageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackageByIdQuery(baseOptions: Apollo.QueryHookOptions<PackageByIdQuery, PackageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageByIdQuery, PackageByIdQueryVariables>(PackageByIdDocument, options);
      }
export function usePackageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageByIdQuery, PackageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageByIdQuery, PackageByIdQueryVariables>(PackageByIdDocument, options);
        }
export type PackageByIdQueryHookResult = ReturnType<typeof usePackageByIdQuery>;
export type PackageByIdLazyQueryHookResult = ReturnType<typeof usePackageByIdLazyQuery>;
export type PackageByIdQueryResult = Apollo.QueryResult<PackageByIdQuery, PackageByIdQueryVariables>;
export const PayVerificationDocument = gql`
    query PayVerification($code: String!, $amount: Decimal!, $recaptchaToken: String!) {
  payVerification(code: $code, amount: $amount, recaptchaToken: $recaptchaToken) {
    status
    errors {
      ...ErrorType
    }
    documentUrl
  }
}
    ${ErrorTypeFragmentDoc}`;

/**
 * __usePayVerificationQuery__
 *
 * To run a query within a React component, call `usePayVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayVerificationQuery({
 *   variables: {
 *      code: // value for 'code'
 *      amount: // value for 'amount'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function usePayVerificationQuery(baseOptions: Apollo.QueryHookOptions<PayVerificationQuery, PayVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayVerificationQuery, PayVerificationQueryVariables>(PayVerificationDocument, options);
      }
export function usePayVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayVerificationQuery, PayVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayVerificationQuery, PayVerificationQueryVariables>(PayVerificationDocument, options);
        }
export type PayVerificationQueryHookResult = ReturnType<typeof usePayVerificationQuery>;
export type PayVerificationLazyQueryHookResult = ReturnType<typeof usePayVerificationLazyQuery>;
export type PayVerificationQueryResult = Apollo.QueryResult<PayVerificationQuery, PayVerificationQueryVariables>;
export const PoliciesDocument = gql`
    query Policies($policyType: PolicyTypeEnum!) {
  policies(policyType: $policyType) {
    status
    errors {
      ...ErrorType
    }
    policies
  }
}
    ${ErrorTypeFragmentDoc}`;

/**
 * __usePoliciesQuery__
 *
 * To run a query within a React component, call `usePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoliciesQuery({
 *   variables: {
 *      policyType: // value for 'policyType'
 *   },
 * });
 */
export function usePoliciesQuery(baseOptions: Apollo.QueryHookOptions<PoliciesQuery, PoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PoliciesQuery, PoliciesQueryVariables>(PoliciesDocument, options);
      }
export function usePoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoliciesQuery, PoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PoliciesQuery, PoliciesQueryVariables>(PoliciesDocument, options);
        }
export type PoliciesQueryHookResult = ReturnType<typeof usePoliciesQuery>;
export type PoliciesLazyQueryHookResult = ReturnType<typeof usePoliciesLazyQuery>;
export type PoliciesQueryResult = Apollo.QueryResult<PoliciesQuery, PoliciesQueryVariables>;
export const SlidesDocument = gql`
    query Slides($skip: Int, $take: Int, $report: Boolean, $searchFields: [SlideSearchFieldInput], $sortFields: SlideSortFieldInput) {
  slides(
    report: $report
    skip: $skip
    take: $take
    searchFields: $searchFields
    sortFields: $sortFields
  ) {
    status
    errors {
      ...ErrorType
    }
    pageInfo {
      ...PageInfoType
    }
    objects {
      title
      subtitle
      image {
        ...ImageType
      }
      buttonText
      buttonLink
      section
    }
  }
}
    ${ErrorTypeFragmentDoc}
${PageInfoTypeFragmentDoc}
${ImageTypeFragmentDoc}`;

/**
 * __useSlidesQuery__
 *
 * To run a query within a React component, call `useSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlidesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      report: // value for 'report'
 *      searchFields: // value for 'searchFields'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useSlidesQuery(baseOptions?: Apollo.QueryHookOptions<SlidesQuery, SlidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlidesQuery, SlidesQueryVariables>(SlidesDocument, options);
      }
export function useSlidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlidesQuery, SlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlidesQuery, SlidesQueryVariables>(SlidesDocument, options);
        }
export type SlidesQueryHookResult = ReturnType<typeof useSlidesQuery>;
export type SlidesLazyQueryHookResult = ReturnType<typeof useSlidesLazyQuery>;
export type SlidesQueryResult = Apollo.QueryResult<SlidesQuery, SlidesQueryVariables>;
export const SocialMediaDocument = gql`
    query SocialMedia {
  socialMedia {
    status
    errors {
      ...ErrorType
    }
    media {
      facebook
      instagram
      linkedin
      telegram
      pinterest
      youtube
    }
  }
}
    ${ErrorTypeFragmentDoc}`;

/**
 * __useSocialMediaQuery__
 *
 * To run a query within a React component, call `useSocialMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialMediaQuery({
 *   variables: {
 *   },
 * });
 */
export function useSocialMediaQuery(baseOptions?: Apollo.QueryHookOptions<SocialMediaQuery, SocialMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialMediaQuery, SocialMediaQueryVariables>(SocialMediaDocument, options);
      }
export function useSocialMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialMediaQuery, SocialMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialMediaQuery, SocialMediaQueryVariables>(SocialMediaDocument, options);
        }
export type SocialMediaQueryHookResult = ReturnType<typeof useSocialMediaQuery>;
export type SocialMediaLazyQueryHookResult = ReturnType<typeof useSocialMediaLazyQuery>;
export type SocialMediaQueryResult = Apollo.QueryResult<SocialMediaQuery, SocialMediaQueryVariables>;
export const VerifiedItineraryPdfDocument = gql`
    query VerifiedItineraryPdf($verificationCode: String!, $passport: String!, $recaptchaToken: String!) {
  verifiedItineraryPdf(
    verificationCode: $verificationCode
    passport: $passport
    recaptchaToken: $recaptchaToken
  ) {
    status
    itineraryNumber
    passport
    errors {
      ...ErrorType
    }
  }
}
    ${ErrorTypeFragmentDoc}`;

/**
 * __useVerifiedItineraryPdfQuery__
 *
 * To run a query within a React component, call `useVerifiedItineraryPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifiedItineraryPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifiedItineraryPdfQuery({
 *   variables: {
 *      verificationCode: // value for 'verificationCode'
 *      passport: // value for 'passport'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useVerifiedItineraryPdfQuery(baseOptions: Apollo.QueryHookOptions<VerifiedItineraryPdfQuery, VerifiedItineraryPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifiedItineraryPdfQuery, VerifiedItineraryPdfQueryVariables>(VerifiedItineraryPdfDocument, options);
      }
export function useVerifiedItineraryPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifiedItineraryPdfQuery, VerifiedItineraryPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifiedItineraryPdfQuery, VerifiedItineraryPdfQueryVariables>(VerifiedItineraryPdfDocument, options);
        }
export type VerifiedItineraryPdfQueryHookResult = ReturnType<typeof useVerifiedItineraryPdfQuery>;
export type VerifiedItineraryPdfLazyQueryHookResult = ReturnType<typeof useVerifiedItineraryPdfLazyQuery>;
export type VerifiedItineraryPdfQueryResult = Apollo.QueryResult<VerifiedItineraryPdfQuery, VerifiedItineraryPdfQueryVariables>;
export const WebMessagesDocument = gql`
    query WebMessages($place: String!) {
  webMessages(place: $place) {
    status
    errors {
      ...ErrorType
    }
    objects {
      ...WebMessageType
    }
  }
}
    ${ErrorTypeFragmentDoc}
${WebMessageTypeFragmentDoc}`;

/**
 * __useWebMessagesQuery__
 *
 * To run a query within a React component, call `useWebMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebMessagesQuery({
 *   variables: {
 *      place: // value for 'place'
 *   },
 * });
 */
export function useWebMessagesQuery(baseOptions: Apollo.QueryHookOptions<WebMessagesQuery, WebMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebMessagesQuery, WebMessagesQueryVariables>(WebMessagesDocument, options);
      }
export function useWebMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebMessagesQuery, WebMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebMessagesQuery, WebMessagesQueryVariables>(WebMessagesDocument, options);
        }
export type WebMessagesQueryHookResult = ReturnType<typeof useWebMessagesQuery>;
export type WebMessagesLazyQueryHookResult = ReturnType<typeof useWebMessagesLazyQuery>;
export type WebMessagesQueryResult = Apollo.QueryResult<WebMessagesQuery, WebMessagesQueryVariables>;